var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/card/card.ts
function createCard(props = {}) {
  const { padding = "md", elevation = "md", title, headerContent, bodyContent } = props;
  const root = document.createElement("div");
  root.className = `card card--padding-${padding} card--elevation-${elevation}`;
  if (headerContent) {
    const headerWrap = document.createElement("div");
    headerWrap.className = "card__header";
    headerWrap.appendChild(headerContent);
    root.appendChild(headerWrap);
  } else if (title) {
    const heading = document.createElement("h2");
    heading.className = "card__title";
    heading.textContent = title;
    root.appendChild(heading);
  }
  if (bodyContent) {
    bodyContent.classList.add("card__content");
    root.appendChild(bodyContent);
  }
  return root;
}

// src/components/button/button.ts
function getButtonClassName(options) {
  const { variant = "primary", size = "md", iconOnly = false, selected = false } = options;
  const classes = [`btn`, `btn--${variant}`, `btn--${size}`];
  if (iconOnly) classes.push("btn--icon");
  if (selected) classes.push("btn--selected");
  return classes.join(" ");
}
function createButton(props) {
  const {
    variant = "primary",
    size = "md",
    selected = false,
    disabled = false,
    type = "button",
    label,
    description,
    icon,
    ariaLabel
  } = props;
  const el = document.createElement("button");
  el.type = type;
  const iconOnly = icon != null && icon !== "" && (label == null || label === "");
  el.className = getButtonClassName({ variant, size, iconOnly, selected });
  if (icon != null && icon !== "") {
    const iconSpan = document.createElement("span");
    iconSpan.className = "btn__icon";
    iconSpan.innerHTML = icon;
    el.appendChild(iconSpan);
  }
  if (label != null && label !== "") {
    const labelSpan = document.createElement("span");
    labelSpan.className = "btn__label";
    labelSpan.textContent = label;
    el.appendChild(labelSpan);
  }
  if (description != null && description !== "") {
    const descriptionSpan = document.createElement("span");
    descriptionSpan.className = "btn__description";
    descriptionSpan.textContent = description;
    el.appendChild(descriptionSpan);
  }
  if (ariaLabel != null && ariaLabel !== "") {
    el.setAttribute("aria-label", ariaLabel);
  } else if (label != null && label !== "") {
    el.setAttribute("aria-label", label);
  }
  el.disabled = disabled != null ? disabled : false;
  return el;
}

// src/components/textarea/textarea.ts
var INPUT_LIKE_MIN_HEIGHT = 40;
var DEFAULT_HEIGHT = 96;
function createTextarea(props = {}) {
  const {
    label: labelText,
    placeholder = "",
    value = "",
    disabled = false,
    minHeight = INPUT_LIKE_MIN_HEIGHT,
    height,
    ariaLabel
  } = props;
  const wrap = document.createElement("div");
  wrap.className = "ds-textarea-wrap";
  if (labelText) {
    const label = document.createElement("label");
    label.className = "ds-textarea-wrap__label";
    label.textContent = labelText;
    wrap.appendChild(label);
  }
  const inner = document.createElement("div");
  inner.className = "ds-textarea-wrap__inner";
  wrap.appendChild(inner);
  const textarea = document.createElement("textarea");
  textarea.className = "ds-textarea";
  textarea.placeholder = placeholder;
  textarea.value = value;
  textarea.disabled = disabled;
  textarea.style.minHeight = `${minHeight}px`;
  const initialHeight = height != null ? height : DEFAULT_HEIGHT;
  textarea.style.height = `${initialHeight}px`;
  if (ariaLabel) textarea.setAttribute("aria-label", ariaLabel);
  else if (labelText) textarea.setAttribute("aria-label", labelText);
  inner.appendChild(textarea);
  const resizer = document.createElement("div");
  resizer.className = "ds-textarea-resizer";
  resizer.setAttribute("role", "separator");
  resizer.setAttribute("aria-valuenow", String(initialHeight));
  resizer.setAttribute("aria-label", "Resize textarea height");
  inner.appendChild(resizer);
  function setHeight(px) {
    const clamped = Math.max(minHeight, Math.min(800, px));
    textarea.style.height = `${clamped}px`;
    resizer.setAttribute("aria-valuenow", String(clamped));
  }
  resizer.addEventListener("mousedown", (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = textarea.offsetHeight;
    function onMove(e2) {
      const delta = e2.clientY - startY;
      setHeight(startHeight + delta);
    }
    function onUp() {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    }
    document.body.style.cursor = "ns-resize";
    document.body.style.userSelect = "none";
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  });
  textarea.addEventListener("input", () => {
    const cur = textarea.offsetHeight;
    const scroll = textarea.scrollHeight;
    if (scroll > cur) {
      textarea.style.height = `${scroll}px`;
    }
  });
  return wrap;
}

// src/components/checkbox/checkbox.ts
var _checkboxIdCounter = 0;
function createCheckbox(props) {
  var _a;
  const { label, checked, readonly = false } = props;
  const id = (_a = props.id) != null ? _a : `ds-checkbox-${++_checkboxIdCounter}`;
  const root = document.createElement("div");
  root.className = readonly ? "ds-checkbox ds-checkbox--readonly" : "ds-checkbox";
  const input = document.createElement("input");
  input.type = "checkbox";
  input.id = id;
  input.className = "ds-checkbox__input";
  input.checked = checked;
  if (readonly) {
    input.tabIndex = -1;
  }
  const labelEl = document.createElement("label");
  labelEl.htmlFor = id;
  labelEl.className = "ds-checkbox__label";
  labelEl.textContent = label;
  root.appendChild(input);
  root.appendChild(labelEl);
  return {
    root,
    setChecked: (v) => {
      input.checked = v;
    }
  };
}

// src/components/radio/radio.ts
var _radioGroupCounter = 0;
function createRadioGroup(props) {
  var _a;
  const { value, options, ariaLabel, onChange } = props;
  const groupName = (_a = props.name) != null ? _a : `ds-radio-group-${++_radioGroupCounter}`;
  let currentValue = value;
  const inputsByValue = /* @__PURE__ */ new Map();
  const root = document.createElement("div");
  root.className = "ds-radio-group";
  root.setAttribute("role", "radiogroup");
  if (ariaLabel) root.setAttribute("aria-label", ariaLabel);
  function setValue(next) {
    currentValue = next;
    for (const [optionValue, input] of inputsByValue.entries()) {
      input.checked = optionValue === next;
    }
  }
  for (const option of options) {
    const optionEl = document.createElement("label");
    optionEl.className = "ds-radio-group__option";
    const input = document.createElement("input");
    input.type = "radio";
    input.className = "ds-radio-group__input";
    input.name = groupName;
    input.value = option.value;
    input.checked = option.value === currentValue;
    input.setAttribute("aria-label", option.label);
    input.addEventListener("change", () => {
      if (!input.checked) return;
      setValue(option.value);
      onChange == null ? void 0 : onChange(option.value);
    });
    inputsByValue.set(option.value, input);
    const labelWrap = document.createElement("span");
    labelWrap.className = "ds-radio-group__text";
    const label = document.createElement("span");
    label.className = "ds-radio-group__label";
    label.textContent = option.label;
    labelWrap.appendChild(label);
    if (option.description && option.description.trim() !== "") {
      const description = document.createElement("span");
      description.className = "ds-radio-group__description";
      description.textContent = option.description;
      labelWrap.appendChild(description);
    }
    optionEl.appendChild(input);
    optionEl.appendChild(labelWrap);
    root.appendChild(optionEl);
  }
  return {
    root,
    setValue,
    getValue: () => currentValue
  };
}

// src/components/toggle/toggle.ts
var _toggleIdCounter = 0;
function applyChecked(button, checked, iconSlot, iconOff, iconOn) {
  button.setAttribute("aria-checked", String(checked));
  button.classList.toggle("ds-toggle__switch--on", checked);
  if (iconSlot && iconOff !== void 0 && iconOn !== void 0) {
    iconSlot.innerHTML = checked ? iconOn : iconOff;
  }
}
function createToggle(props) {
  var _a;
  const { label, labelPosition = "left", iconOff, iconOn, ariaLabel, checked, readonly = false, onChange } = props;
  const id = (_a = props.id) != null ? _a : `ds-toggle-${++_toggleIdCounter}`;
  const useIcons = iconOff !== void 0 && iconOn !== void 0;
  const root = document.createElement("div");
  root.className = readonly ? "ds-toggle ds-toggle--readonly" : "ds-toggle";
  if (!useIcons && label !== void 0) {
    root.classList.add(labelPosition === "right" ? "ds-toggle--label-right" : "ds-toggle--label-left");
  }
  if (ariaLabel) root.setAttribute("aria-label", ariaLabel);
  let iconSlot = null;
  if (useIcons) {
    iconSlot = document.createElement("span");
    iconSlot.className = "ds-toggle__icon";
    iconSlot.setAttribute("aria-hidden", "true");
    iconSlot.innerHTML = checked ? iconOn : iconOff;
  }
  const button = document.createElement("button");
  button.type = "button";
  button.id = id;
  button.role = "switch";
  button.className = "ds-toggle__switch";
  if (ariaLabel) button.setAttribute("aria-label", ariaLabel);
  applyChecked(button, checked, iconSlot, iconOff, iconOn);
  if (readonly) {
    button.tabIndex = -1;
    button.setAttribute("aria-readonly", "true");
  } else {
    button.addEventListener("click", () => {
      const next = button.getAttribute("aria-checked") !== "true";
      applyChecked(button, next, iconSlot, iconOff, iconOn);
      onChange == null ? void 0 : onChange(next);
    });
  }
  if (!useIcons && label !== void 0) {
    const labelEl = document.createElement("label");
    labelEl.htmlFor = id;
    labelEl.className = "ds-toggle__label";
    labelEl.textContent = label;
    if (labelPosition === "right") {
      root.appendChild(button);
      root.appendChild(labelEl);
    } else {
      root.appendChild(labelEl);
      root.appendChild(button);
    }
  } else {
    root.appendChild(button);
    if (useIcons && iconSlot) root.appendChild(iconSlot);
  }
  return {
    root,
    button,
    setChecked: (v) => applyChecked(button, v, iconSlot, iconOff, iconOn)
  };
}

// src/components/input/input.ts
function createInput(props = {}) {
  const { disabled = false, placeholder = "", type = "text", value = "", label: labelText, size = "md" } = props;
  const wrap = document.createElement("div");
  wrap.className = "input-wrap";
  if (labelText) {
    const label = document.createElement("label");
    label.className = "input-wrap__label";
    label.textContent = labelText;
    wrap.appendChild(label);
  }
  const input = document.createElement("input");
  input.type = type;
  input.className = size === "xl" ? "input input--xl" : "input";
  input.placeholder = placeholder;
  input.value = value;
  input.disabled = disabled;
  if (labelText) input.setAttribute("aria-label", labelText);
  wrap.appendChild(input);
  return wrap;
}

// src/components/table/table.ts
function createTable(props) {
  const { headers, rows, variant = "default", scrollable = true, wrapHeaders = false } = props;
  const wrap = document.createElement("div");
  wrap.className = scrollable ? "table-wrap table-wrap--scrollable" : "table-wrap table-wrap--no-scroll";
  const table = document.createElement("table");
  table.setAttribute("role", "table");
  table.className = `table table--${variant}` + (wrapHeaders ? " table--wrap-headers" : "");
  const thead = document.createElement("thead");
  const trHead = document.createElement("tr");
  headers.forEach((h) => {
    const th = document.createElement("th");
    th.textContent = h;
    trHead.appendChild(th);
  });
  thead.appendChild(trHead);
  table.appendChild(thead);
  const tbody = document.createElement("tbody");
  rows.forEach((row) => {
    const tr = document.createElement("tr");
    row.forEach((cell) => {
      const td = document.createElement("td");
      const text = cell != null ? cell : "";
      td.textContent = text;
      if (text) td.setAttribute("title", text);
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });
  table.appendChild(tbody);
  wrap.appendChild(table);
  return wrap;
}

// src/components/tooltip/tooltip.ts
function createTooltip(props) {
  const { trigger, text, position = "top" } = props;
  const root = document.createElement("div");
  root.className = "tooltip-wrap";
  const tip = document.createElement("span");
  tip.className = `tooltip tooltip--${position}`;
  tip.setAttribute("role", "tooltip");
  tip.textContent = text;
  tip.id = "tooltip-" + Math.random().toString(36).slice(2, 9);
  root.appendChild(trigger);
  root.appendChild(tip);
  trigger.setAttribute("aria-describedby", tip.id);
  trigger.addEventListener("mouseenter", () => tip.classList.add("is-visible"));
  trigger.addEventListener("mouseleave", () => tip.classList.remove("is-visible"));
  trigger.addEventListener("focus", () => tip.classList.add("is-visible"));
  trigger.addEventListener("blur", () => tip.classList.remove("is-visible"));
  return root;
}

// src/components/badge/badge.ts
var DEFAULT_REMOVE_ICON = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1.5 1.5L8.5 8.5M8.5 1.5L1.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
function createBadge(props) {
  const { label, onRemove, removeAriaLabel = "Remove", removeIcon = DEFAULT_REMOVE_ICON } = props;
  const root = document.createElement("span");
  root.className = "ds-badge" + (onRemove ? " ds-badge--removable" : "");
  const text = document.createElement("span");
  text.className = "ds-badge__label";
  text.textContent = label;
  root.appendChild(text);
  if (onRemove) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ds-badge__remove";
    btn.setAttribute("aria-label", removeAriaLabel);
    btn.innerHTML = removeIcon;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      onRemove();
    });
    root.appendChild(btn);
  }
  return { root };
}

// src/components/citationChip/citationChip.ts
function createCitationChip(props) {
  const { label, title, onClick } = props;
  const button = document.createElement("button");
  button.type = "button";
  button.className = "ds-citation-chip";
  button.textContent = label;
  button.setAttribute("aria-label", title || label);
  if (title) {
    button.title = title;
  }
  if (onClick) {
    button.addEventListener("click", onClick);
  }
  return button;
}

// src/components/userMenu/userMenu.ts
function createUserMenu(props) {
  var _a;
  const {
    triggerContent,
    panelContent,
    triggerAriaLabel,
    panelRole,
    rootClass = "",
    triggerClass = "",
    panelClass = "",
    openClass = "is-open",
    variant = "slideout",
    corner = "top-right",
    paneTarget = "right",
    onPaneToggle,
    isPaneOpen,
    modalOverlayClass = "user-menu__overlay",
    modalClass = "user-menu__modal",
    closeOnOutsideClick = true,
    stackIndex = 0,
    stackGapPx = 10
  } = props;
  function mergeClassNames(...classNames) {
    const seen = /* @__PURE__ */ new Set();
    for (const chunk of classNames) {
      for (const token of chunk.split(/\s+/).filter(Boolean)) {
        seen.add(token);
      }
    }
    return Array.from(seen).join(" ");
  }
  const root = document.createElement("div");
  root.className = mergeClassNames(
    "user-menu",
    rootClass,
    "ds-floating-action",
    `ds-floating-action--${corner}`,
    `ds-floating-action--${variant}`,
    `ds-floating-action--pane-${paneTarget}`
  );
  const normalizedStackIndex = Math.max(0, Math.floor(stackIndex));
  const stackOffsetPx = 8 + normalizedStackIndex * (44 + Math.max(0, stackGapPx));
  root.style.setProperty("--ds-floating-action-stack-offset", `${stackOffsetPx}px`);
  root.setAttribute("aria-label", "User menu");
  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = mergeClassNames("user-menu__trigger", triggerClass);
  trigger.setAttribute("aria-label", triggerAriaLabel);
  trigger.setAttribute("aria-expanded", "false");
  if (variant !== "pane-toggle") trigger.setAttribute("aria-haspopup", "true");
  trigger.dataset.paneTarget = paneTarget;
  trigger.appendChild(triggerContent);
  const panel = document.createElement("div");
  panel.className = mergeClassNames("user-menu__panel", panelClass);
  panel.setAttribute("aria-hidden", "true");
  if (panelRole) panel.setAttribute("role", panelRole);
  panel.appendChild(panelContent);
  const modalOverlay = document.createElement("div");
  modalOverlay.className = mergeClassNames("user-menu__overlay", modalOverlayClass);
  modalOverlay.setAttribute("aria-hidden", "true");
  modalOverlay.hidden = true;
  modalOverlay.style.display = "none";
  const modal = document.createElement("div");
  modal.className = mergeClassNames("user-menu__modal", modalClass);
  modal.appendChild(panel);
  modalOverlay.appendChild(modal);
  root.appendChild(trigger);
  if (variant === "modal") root.appendChild(modalOverlay);
  else if (variant === "slideout") root.appendChild(panel);
  let paneOpen = (_a = isPaneOpen == null ? void 0 : isPaneOpen()) != null ? _a : false;
  if (variant === "pane-toggle") {
    trigger.setAttribute("aria-expanded", String(paneOpen));
  }
  function isOpen() {
    if (variant === "pane-toggle") return paneOpen;
    return panel.classList.contains(openClass);
  }
  function close() {
    if (variant === "pane-toggle") {
      paneOpen = false;
      onPaneToggle == null ? void 0 : onPaneToggle(false, paneTarget);
    } else {
      panel.classList.remove(openClass);
      panel.setAttribute("aria-hidden", "true");
      if (variant === "modal") {
        modalOverlay.setAttribute("aria-hidden", "true");
        modalOverlay.hidden = true;
        modalOverlay.style.display = "none";
      }
    }
    trigger.setAttribute("aria-expanded", "false");
  }
  function open() {
    if (variant === "pane-toggle") {
      paneOpen = true;
      onPaneToggle == null ? void 0 : onPaneToggle(true, paneTarget);
    } else {
      panel.classList.add(openClass);
      panel.setAttribute("aria-hidden", "false");
      if (variant === "modal") {
        modalOverlay.hidden = false;
        modalOverlay.style.display = "flex";
        modalOverlay.setAttribute("aria-hidden", "false");
      }
    }
    trigger.setAttribute("aria-expanded", "true");
  }
  function toggle() {
    if (isOpen()) close();
    else open();
  }
  trigger.addEventListener("click", (e) => {
    var _a2;
    e.stopPropagation();
    if (variant === "pane-toggle") paneOpen = (_a2 = isPaneOpen == null ? void 0 : isPaneOpen()) != null ? _a2 : paneOpen;
    toggle();
  });
  if (variant === "modal") {
    modalOverlay.addEventListener("click", (e) => {
      if (!closeOnOutsideClick) return;
      if (e.target === modalOverlay) close();
    });
  }
  document.addEventListener("click", (e) => {
    if (!closeOnOutsideClick) return;
    if (!isOpen()) return;
    if (variant === "pane-toggle") return;
    if (!root.contains(e.target)) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) {
      close();
    }
  });
  return {
    root,
    getTrigger: () => trigger,
    getPanel: () => panel,
    open,
    close,
    toggle,
    isOpen
  };
}

// src/components/dropdown/dropdown.ts
function buildDropdown(props, selected, setSelected) {
  var _a;
  const {
    id,
    label,
    options,
    placeholder = "Select\u2026",
    listboxAriaLabel = "Options",
    mode = "single",
    rightToggleIcon
  } = props;
  const root = document.createElement("div");
  root.className = "ds-field ds-dropdown-wrap";
  if (label) {
    const labelEl = document.createElement("label");
    labelEl.className = "ds-label";
    labelEl.htmlFor = id;
    labelEl.textContent = label;
    root.appendChild(labelEl);
  }
  const wrap = document.createElement("div");
  wrap.className = "ds-dropdown";
  root.appendChild(wrap);
  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.id = id;
  trigger.className = "ds-dropdown-trigger";
  trigger.setAttribute("aria-haspopup", "listbox");
  trigger.setAttribute("aria-expanded", "false");
  const triggerInner = document.createElement("div");
  triggerInner.className = "ds-dropdown-trigger-inner";
  const placeholderEl = document.createElement("span");
  placeholderEl.className = "ds-dropdown-placeholder";
  placeholderEl.textContent = placeholder;
  const valueEl = document.createElement("span");
  valueEl.className = "ds-dropdown-value";
  valueEl.style.display = "none";
  const multiValueEl = document.createElement("span");
  multiValueEl.className = "ds-dropdown-multi-value";
  multiValueEl.style.display = "none";
  const multiCountEl = document.createElement("span");
  multiCountEl.className = "ds-dropdown-multi-count";
  multiCountEl.setAttribute("aria-hidden", "true");
  multiCountEl.style.display = "none";
  const measureEl = document.createElement("span");
  measureEl.className = "ds-dropdown-measure";
  measureEl.setAttribute("aria-hidden", "true");
  triggerInner.appendChild(placeholderEl);
  triggerInner.appendChild(valueEl);
  triggerInner.appendChild(multiValueEl);
  triggerInner.appendChild(multiCountEl);
  trigger.appendChild(triggerInner);
  trigger.appendChild(measureEl);
  let toggleBtn = null;
  if (rightToggleIcon) {
    let asc = (_a = rightToggleIcon.initialAsc) != null ? _a : true;
    toggleBtn = document.createElement("button");
    toggleBtn.type = "button";
    toggleBtn.className = "ds-dropdown-toggle-icon";
    const iconSpan = document.createElement("span");
    iconSpan.className = "ds-dropdown-toggle-icon-inner";
    iconSpan.innerHTML = asc ? rightToggleIcon.iconUp : rightToggleIcon.iconDown;
    toggleBtn.appendChild(iconSpan);
    const updateA11y = () => {
      toggleBtn.setAttribute(
        "aria-label",
        asc ? rightToggleIcon.ariaLabelAsc : rightToggleIcon.ariaLabelDesc
      );
    };
    updateA11y();
    toggleBtn.addEventListener("click", (e) => {
      var _a2;
      e.preventDefault();
      e.stopPropagation();
      asc = !asc;
      iconSpan.innerHTML = asc ? rightToggleIcon.iconUp : rightToggleIcon.iconDown;
      updateA11y();
      (_a2 = rightToggleIcon.onToggle) == null ? void 0 : _a2.call(rightToggleIcon, asc);
    });
  }
  const dropdown = document.createElement("div");
  dropdown.className = "ds-dropdown-panel";
  dropdown.setAttribute("role", "listbox");
  dropdown.setAttribute("aria-multiselectable", mode === "multi" ? "true" : "false");
  dropdown.setAttribute("aria-label", listboxAriaLabel);
  return { root, trigger, dropdown, wrap, toggleBtn };
}
function createDropdown(props) {
  const { placeholder = "Select\u2026", initialSelected, onChange, mode = "single" } = props;
  const initial = Array.isArray(initialSelected) ? initialSelected : initialSelected != null ? [initialSelected] : [];
  let selected = [...initial];
  let currentOptions = [...props.options];
  const { root, trigger, dropdown, wrap, toggleBtn } = buildDropdown(
    props,
    selected,
    (v) => {
      selected = v;
    }
  );
  function updateOptionHighlights() {
    dropdown.querySelectorAll(".ds-dropdown-option").forEach((el) => {
      var _a;
      const v = (_a = el.dataset.value) != null ? _a : "";
      const isSel = selected.includes(v);
      el.classList.toggle("is-selected", isSel);
      el.setAttribute("aria-selected", String(isSel));
    });
  }
  function updateTriggerDisplay() {
    var _a, _b, _c;
    const placeholderEl = wrap.querySelector(".ds-dropdown-placeholder");
    const valueEl = wrap.querySelector(".ds-dropdown-value");
    const multiValueEl = wrap.querySelector(".ds-dropdown-multi-value");
    const multiCountEl = wrap.querySelector(".ds-dropdown-multi-count");
    if (!placeholderEl || !valueEl || !multiValueEl) return;
    if (mode === "single") {
      if (selected.length === 0) {
        placeholderEl.style.display = "";
        placeholderEl.textContent = placeholder;
        valueEl.style.display = "none";
        valueEl.textContent = "";
      } else {
        const opt = currentOptions.find((o) => o.value === selected[0]);
        placeholderEl.style.display = "none";
        valueEl.textContent = (_a = opt == null ? void 0 : opt.label) != null ? _a : selected[0];
        valueEl.style.display = "";
      }
      multiValueEl.style.display = "none";
      multiValueEl.textContent = "";
      if (multiCountEl) multiCountEl.style.display = "none";
      return;
    }
    if (selected.length === 0) {
      placeholderEl.style.display = "";
      placeholderEl.textContent = placeholder;
      multiValueEl.style.display = "none";
      multiValueEl.textContent = "";
      if (multiCountEl) multiCountEl.style.display = "none";
      return;
    }
    placeholderEl.style.display = "none";
    const labels = selected.map((v) => {
      var _a2, _b2;
      return (_b2 = (_a2 = currentOptions.find((o) => o.value === v)) == null ? void 0 : _a2.label) != null ? _b2 : v;
    });
    const n = labels.length;
    const measureEl = wrap.querySelector(".ds-dropdown-measure");
    const triggerEl = wrap.querySelector(".ds-dropdown-trigger");
    let displayText = labels.join(", ");
    if (measureEl && triggerEl && n > 0) {
      const wrapWidth = wrap.getBoundingClientRect().width;
      const style = (_c = (_b = triggerEl.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.getComputedStyle(triggerEl);
      const padding = style ? (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0) : 24;
      const availableWidth = wrapWidth - padding - 4;
      if (availableWidth >= 40) {
        let visibleCount = 0;
        for (let i = 0; i <= n; i++) {
          const suffix = i >= n ? "" : (i === 0 ? "" : ", ") + "\u2026and " + (n - i) + " more";
          const candidate = i === 0 ? "\u2026and " + n + " more" : labels.slice(0, i).join(", ") + suffix;
          measureEl.textContent = candidate;
          if (measureEl.getBoundingClientRect().width <= availableWidth) {
            visibleCount = i;
            displayText = candidate;
          } else break;
        }
        if (visibleCount === 0 && n > 0) displayText = "\u2026and " + n + " more";
      }
    }
    multiValueEl.textContent = displayText;
    multiValueEl.style.display = "";
    if (multiCountEl) {
      multiCountEl.textContent = `(${n})`;
      multiCountEl.style.display = "";
    }
  }
  function renderOptionButtons(opts) {
    opts.forEach((opt) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ds-dropdown-option";
      btn.setAttribute("role", "option");
      btn.dataset.value = opt.value;
      btn.textContent = opt.label;
      btn.addEventListener("click", (e) => {
        var _a;
        e.preventDefault();
        const v = (_a = e.currentTarget.dataset.value) != null ? _a : "";
        if (mode === "single") {
          selected = [v];
          dropdown.classList.remove("is-open");
          trigger.setAttribute("aria-expanded", "false");
        } else {
          const idx = selected.indexOf(v);
          if (idx === -1) selected = [...selected, v];
          else selected = selected.filter((x) => x !== v);
        }
        updateOptionHighlights();
        updateTriggerDisplay();
        onChange == null ? void 0 : onChange(selected);
      });
      dropdown.appendChild(btn);
    });
  }
  renderOptionButtons(currentOptions);
  wrap.appendChild(trigger);
  if (toggleBtn) wrap.appendChild(toggleBtn);
  wrap.appendChild(dropdown);
  function positionPanel() {
    var _a;
    const panel = dropdown;
    const triggerRect = trigger.getBoundingClientRect();
    const maxHeight = 14 * 16;
    const gap = 8;
    const spaceBelow = ((_a = document.documentElement.clientHeight) != null ? _a : window.innerHeight) - triggerRect.bottom;
    const openUp = spaceBelow < maxHeight + gap && triggerRect.top >= maxHeight + gap;
    panel.classList.toggle("ds-dropdown-panel--above", openUp);
  }
  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    const open = dropdown.classList.toggle("is-open");
    trigger.setAttribute("aria-expanded", String(open));
    if (open) {
      positionPanel();
      updateTriggerDisplay();
      updateOptionHighlights();
    }
  });
  document.addEventListener("click", (e) => {
    if (dropdown.classList.contains("is-open") && !wrap.contains(e.target)) {
      dropdown.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    }
  });
  if (mode === "multi" && typeof ResizeObserver !== "undefined") {
    const ro = new ResizeObserver(() => {
      if (selected.length > 0) requestAnimationFrame(() => updateTriggerDisplay());
    });
    ro.observe(wrap);
  }
  function getSelected() {
    return selected;
  }
  function setSelected(keys) {
    selected = keys.filter((v) => currentOptions.some((o) => o.value === v));
    updateOptionHighlights();
    updateTriggerDisplay();
  }
  function setOptions(newOptions) {
    currentOptions = newOptions;
    dropdown.querySelectorAll(".ds-dropdown-option").forEach((el) => el.remove());
    renderOptionButtons(currentOptions);
    selected = selected.filter((v) => currentOptions.some((o) => o.value === v));
    updateOptionHighlights();
    updateTriggerDisplay();
  }
  function setOptionLabel(value, label) {
    const opt = wrap.querySelector(`.ds-dropdown-option[data-value="${value}"]`);
    if (opt) opt.textContent = label;
    if (mode === "single" && selected[0] === value) {
      const valueEl = wrap.querySelector(".ds-dropdown-value");
      if (valueEl) valueEl.textContent = label;
    }
  }
  updateOptionHighlights();
  updateTriggerDisplay();
  return { root, trigger, dropdown, getSelected, setSelected, setOptions, setOptionLabel };
}
function createMultiSelect(props) {
  var _a, _b;
  return createDropdown(__spreadProps(__spreadValues({}, props), {
    placeholder: (_a = props.placeholder) != null ? _a : "All",
    initialSelected: (_b = props.initialSelected) != null ? _b : [],
    mode: "multi"
  }));
}

// src/utilities/errorMessages.ts
function hasStatus(err) {
  return typeof err === "object" && err !== null && typeof err.status === "number" && typeof err.message === "string";
}
function isAuthRequired(err) {
  if (typeof err === "object" && err !== null) {
    const name = err.name;
    return name === "AuthRequiredError";
  }
  return false;
}
function formatResourceFetchErrorMessage(error, resourceLabel, id) {
  if (isAuthRequired(error)) {
    return "Authentication required. Please log in first.";
  }
  if (hasStatus(error)) {
    if (error.status === 404) {
      return `${resourceLabel} not found: "${id}". Check the ID and try again.`;
    }
    if (error.status === 401) {
      return "Authentication failed. Please log in again.";
    }
    return `Request failed (${error.status}): ${error.message}`;
  }
  const msg = String(error);
  if (msg.includes("Failed to fetch") || msg.includes("NetworkError") || msg.includes("ERR_FAILED")) {
    return "Could not reach the API. Check that the REST API is running and CORS is configured.";
  }
  return `Request failed: ${msg}`;
}

// src/components/lookupFieldGroup/lookupFieldGroup.ts
var MAGNIFYING_GLASS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
function createLookupFieldGroup(props) {
  const {
    label,
    placeholder = "ID or code",
    resourceLabel,
    fetchById,
    onResult,
    buttonAriaLabel = "Lookup",
    trailingIcon,
    trailingIconAriaLabel,
    onTrailingIconClick,
    validate
  } = props;
  const root = document.createElement("div");
  root.className = "ds-lookup-field-group";
  const inputWrap = createInput({ label, placeholder, value: "" });
  const inputEl = inputWrap.querySelector(".input");
  if (!inputEl) throw new Error("LookupFieldGroup: input element not found");
  const inputContainer = document.createElement("div");
  inputContainer.className = "ds-lookup-field-group__field";
  const spinner = document.createElement("div");
  spinner.className = "ds-search-field-spinner";
  spinner.setAttribute("aria-hidden", "true");
  inputWrap.removeChild(inputEl);
  inputContainer.appendChild(inputEl);
  inputContainer.appendChild(spinner);
  if (trailingIcon != null && onTrailingIconClick != null) {
    const trailingBtn = document.createElement("button");
    trailingBtn.type = "button";
    trailingBtn.className = "ds-lookup-field-group__trailing-icon";
    const tooltipLabel = trailingIconAriaLabel != null ? trailingIconAriaLabel : "Use Selected Cell";
    trailingBtn.setAttribute("aria-label", tooltipLabel);
    trailingBtn.title = tooltipLabel;
    trailingBtn.innerHTML = trailingIcon;
    trailingBtn.addEventListener("click", (e) => {
      e.preventDefault();
      onTrailingIconClick == null ? void 0 : onTrailingIconClick(runLookup);
    });
    inputContainer.appendChild(trailingBtn);
  }
  inputWrap.appendChild(inputContainer);
  const errorEl = document.createElement("span");
  errorEl.className = "ds-lookup-field-group__error";
  errorEl.setAttribute("role", "alert");
  errorEl.setAttribute("aria-live", "polite");
  errorEl.hidden = true;
  inputWrap.appendChild(errorEl);
  root.appendChild(inputWrap);
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "ds-lookup-field-group__btn";
  btn.setAttribute("aria-label", buttonAriaLabel);
  btn.innerHTML = MAGNIFYING_GLASS_SVG;
  root.appendChild(btn);
  function setLoading(loading) {
    inputContainer.classList.toggle("is-loading", loading);
    btn.disabled = loading;
  }
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    inputContainer.classList.add("has-error");
    inputEl.setAttribute("aria-invalid", "true");
  }
  function clearError() {
    errorEl.textContent = "";
    errorEl.hidden = true;
    inputContainer.classList.remove("has-error");
    inputEl.removeAttribute("aria-invalid");
  }
  function setValue(value) {
    inputEl.value = value;
    clearError();
  }
  function runLookup(id) {
    return __async(this, null, function* () {
      var _a, _b;
      const value = (id != null ? id : inputEl.value).trim();
      if (!value) return;
      if (id != null) inputEl.value = id;
      clearError();
      if (validate) {
        const result = validate(value);
        if (!result.valid) {
          showError((_a = result.error) != null ? _a : "Invalid ID.");
          return;
        }
      }
      setLoading(true);
      try {
        const data = yield fetchById(value);
        onResult(data);
      } catch (err) {
        showError(formatResourceFetchErrorMessage(err, (_b = resourceLabel != null ? resourceLabel : label) != null ? _b : "Resource", value));
      } finally {
        setLoading(false);
      }
    });
  }
  btn.addEventListener("click", () => runLookup());
  inputEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter") runLookup();
  });
  return { root, input: inputEl, setValue, runLookup };
}

// src/components/searchField/searchField.ts
function renderMessage(panel, text) {
  panel.innerHTML = "";
  const msg = document.createElement("div");
  msg.className = "ds-search-field-message";
  msg.textContent = text;
  msg.setAttribute("aria-live", "polite");
  panel.appendChild(msg);
}
function renderOptions(panel, items, getItemLabel, inputEl, onSelect, close) {
  panel.innerHTML = "";
  panel.setAttribute("role", "listbox");
  panel.setAttribute("aria-label", "Search results");
  items.forEach((item, i) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ds-dropdown-option";
    btn.setAttribute("role", "option");
    btn.dataset.index = String(i);
    btn.textContent = getItemLabel(item);
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      inputEl.value = getItemLabel(item);
      close();
      onSelect(item);
    });
    panel.appendChild(btn);
  });
}
function createSearchField(props) {
  const {
    label = "Search",
    placeholder = "Type to search\u2026",
    minChars = 2,
    debounceMs = 400,
    maxResults = 20,
    fetchResults,
    getItemLabel,
    onSelect = () => {
    }
  } = props;
  const root = document.createElement("div");
  root.className = "ds-field ds-search-field-wrap";
  const inner = document.createElement("div");
  inner.className = "ds-dropdown";
  root.appendChild(inner);
  const inputWrap = createInput({ label, placeholder, value: "" });
  const inputEl = inputWrap.querySelector(".input");
  if (!inputEl) throw new Error("SearchField: input element not found");
  const fieldBox = document.createElement("div");
  fieldBox.className = "ds-search-field-input-box";
  const spinner = document.createElement("div");
  spinner.className = "ds-search-field-spinner";
  spinner.setAttribute("aria-hidden", "true");
  inputWrap.removeChild(inputEl);
  fieldBox.appendChild(inputEl);
  fieldBox.appendChild(spinner);
  inputWrap.appendChild(fieldBox);
  inner.appendChild(inputWrap);
  const panel = document.createElement("div");
  panel.className = "ds-dropdown-panel";
  panel.setAttribute("role", "listbox");
  panel.setAttribute("aria-label", "Search results");
  inner.appendChild(panel);
  function close() {
    panel.classList.remove("is-open");
    inputEl.setAttribute("aria-expanded", "false");
  }
  let debounceTimer = null;
  inputEl.setAttribute("aria-haspopup", "listbox");
  inputEl.setAttribute("aria-expanded", "false");
  inputEl.addEventListener("input", () => {
    if (debounceTimer) clearTimeout(debounceTimer);
    const q = inputEl.value.trim();
    panel.classList.remove("is-open");
    panel.innerHTML = "";
    if (q.length === 0) return;
    if (q.length < minChars) {
      panel.classList.add("is-open");
      renderMessage(panel, `Type at least ${minChars} characters to search.`);
      inputEl.setAttribute("aria-expanded", "true");
      return;
    }
    debounceTimer = setTimeout(() => __async(null, null, function* () {
      debounceTimer = null;
      root.classList.add("is-loading");
      try {
        const results = yield fetchResults(q);
        root.classList.remove("is-loading");
        const arr = Array.isArray(results) ? results : [];
        panel.classList.add("is-open");
        inputEl.setAttribute("aria-expanded", "true");
        if (arr.length === 0) {
          renderMessage(panel, "No results.");
        } else {
          const slice = arr.slice(0, maxResults);
          renderOptions(panel, slice, getItemLabel, inputEl, onSelect, close);
        }
      } catch (err) {
        root.classList.remove("is-loading");
        panel.classList.add("is-open");
        inputEl.setAttribute("aria-expanded", "true");
        renderMessage(
          panel,
          err instanceof Error ? err.message : "Search failed."
        );
      }
    }), debounceMs);
  });
  document.addEventListener("click", (e) => {
    if (panel.classList.contains("is-open") && !inner.contains(e.target)) {
      close();
    }
  });
  return { root, input: inputEl, panel, close };
}

// src/components/tabset/tabset.ts
function createTabset(options) {
  var _a, _b;
  const {
    tabs,
    activeTabId = (_b = (_a = tabs[0]) == null ? void 0 : _a.id) != null ? _b : "",
    type = "primary",
    getPanel,
    ariaLabel = "Tabs",
    overflowDropdown = false,
    overflowDropdownFullWidth = false,
    onTabChange
  } = options;
  const root = document.createElement("div");
  root.className = `ds-tabset ds-tabset--${type}`;
  const header = document.createElement("div");
  header.className = "ds-tabset__header";
  const switcher = document.createElement("div");
  switcher.className = "ds-tabset__switcher";
  const barWrap = document.createElement("div");
  barWrap.className = "ds-tabset__bar-wrap";
  const bar = document.createElement("div");
  bar.className = "ds-tabset__bar";
  bar.setAttribute("role", "tablist");
  bar.setAttribute("aria-label", ariaLabel);
  const tabCountBadges = /* @__PURE__ */ new Map();
  tabs.forEach((tab) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "ds-tabset__tab";
    btn.id = `tabset-tab-${tab.id}`;
    btn.dataset.tabId = tab.id;
    const labelSpan = document.createElement("span");
    labelSpan.className = "ds-tabset__tab-label";
    labelSpan.textContent = tab.label;
    btn.appendChild(labelSpan);
    const countSpan = document.createElement("span");
    countSpan.className = "ds-tabset__tab-count";
    countSpan.setAttribute("aria-hidden", "true");
    countSpan.style.display = "none";
    btn.appendChild(countSpan);
    tabCountBadges.set(tab.id, countSpan);
    btn.setAttribute("role", "tab");
    btn.setAttribute("aria-selected", String(tab.id === activeTabId));
    btn.setAttribute("aria-controls", `tabset-panel-${tab.id}`);
    if (tab.id === activeTabId) btn.classList.add("ds-tabset__tab--active");
    bar.appendChild(btn);
  });
  barWrap.appendChild(bar);
  switcher.appendChild(barWrap);
  let dropdownWrap = null;
  let dropdownSetSelected = null;
  let dropdownSetOptionLabel = null;
  if (overflowDropdown && tabs.length > 0) {
    root.classList.add("ds-tabset--overflow-capable");
    const dropdownEl = document.createElement("div");
    dropdownEl.className = "ds-tabset__dropdown-wrap" + (overflowDropdownFullWidth ? " ds-tabset__dropdown-wrap--full-width" : "");
    switcher.appendChild(dropdownEl);
    dropdownWrap = dropdownEl;
  }
  header.appendChild(switcher);
  root.appendChild(header);
  const contentWrapper = document.createElement("div");
  contentWrapper.className = "ds-tabset__content";
  const panelsByTabId = /* @__PURE__ */ new Map();
  tabs.forEach((tab) => {
    const panel = getPanel(tab.id);
    if (panel) {
      panelsByTabId.set(tab.id, panel);
      panel.id = `tabset-panel-${tab.id}`;
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tabset-tab-${tab.id}`);
      panel.hidden = tab.id !== activeTabId;
      if (!panel.classList.contains("ds-tabset__panel")) {
        panel.classList.add("ds-tabset__panel");
      }
      contentWrapper.appendChild(panel);
    }
  });
  root.appendChild(contentWrapper);
  let currentTabId = activeTabId;
  function showTab(tabId) {
    currentTabId = tabId;
    tabs.forEach((t) => {
      const panel = panelsByTabId.get(t.id);
      const btn = bar.querySelector(`[data-tab-id="${t.id}"]`);
      const isActive = t.id === tabId;
      if (panel) panel.hidden = !isActive;
      if (btn) {
        btn.classList.toggle("ds-tabset__tab--active", isActive);
        btn.setAttribute("aria-selected", String(isActive));
      }
    });
    dropdownSetSelected == null ? void 0 : dropdownSetSelected([tabId]);
    onTabChange == null ? void 0 : onTabChange(tabId);
  }
  bar.addEventListener("click", (e) => {
    var _a2;
    const target = e.target.closest("[data-tab-id]");
    if (target) showTab((_a2 = target.dataset.tabId) != null ? _a2 : "");
  });
  let cleanup = () => {
  };
  if (overflowDropdown && dropdownWrap && tabs.length > 0) {
    const dd = createDropdown({
      id: "tabset-overflow-dropdown",
      options: tabs.map((t) => ({ value: t.id, label: t.label })),
      initialSelected: currentTabId,
      placeholder: "Select section\u2026",
      listboxAriaLabel: ariaLabel,
      onChange: (selected) => {
        if (selected[0]) showTab(selected[0]);
      }
    });
    dropdownSetSelected = dd.setSelected;
    dropdownSetOptionLabel = dd.setOptionLabel;
    dropdownWrap.appendChild(dd.root);
    let ro = null;
    let rafId = null;
    let lastTabsWidthWhenOverflow = 0;
    if (typeof ResizeObserver !== "undefined") {
      const THRESHOLD = 2;
      const checkOverflow = () => {
        const wrapWidth = barWrap.getBoundingClientRect().width;
        if (wrapWidth <= 0) return;
        const tabsWidth = bar.scrollWidth;
        const inOverflow = root.classList.contains("ds-tabset--overflow");
        if (tabsWidth > wrapWidth + THRESHOLD) {
          lastTabsWidthWhenOverflow = tabsWidth;
          root.classList.add("ds-tabset--overflow");
        } else if (inOverflow) {
          const widthToFit = lastTabsWidthWhenOverflow > 0 ? lastTabsWidthWhenOverflow : tabsWidth;
          if (widthToFit <= wrapWidth - THRESHOLD) {
            root.classList.remove("ds-tabset--overflow");
            lastTabsWidthWhenOverflow = 0;
          }
        } else {
          lastTabsWidthWhenOverflow = 0;
        }
      };
      ro = new ResizeObserver(() => {
        if (rafId != null) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = null;
          checkOverflow();
        });
      });
      ro.observe(root);
      rafId = requestAnimationFrame(checkOverflow);
    }
    cleanup = () => {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      ro == null ? void 0 : ro.disconnect();
    };
  }
  function updateTabCount(tabId, count) {
    const el = tabCountBadges.get(tabId);
    const btn = bar.querySelector(`[data-tab-id="${tabId}"]`);
    if (btn) btn.classList.toggle("ds-tabset__tab--empty", count === 0);
    if (dropdownSetOptionLabel) {
      const tab = tabs.find((t) => t.id === tabId);
      if (tab)
        dropdownSetOptionLabel(
          tabId,
          count === null || count < 0 ? tab.label : `${tab.label} (${count})`
        );
    }
    if (!el) return;
    if (count === null || count < 0) {
      el.textContent = "";
      el.style.display = "none";
      return;
    }
    el.textContent = `(${count})`;
    el.style.display = "inline-flex";
  }
  return { root, showTab, updateTabCount, cleanup };
}

// src/components/collapsiblePanel/collapsiblePanel.ts
function createCollapsiblePanel(options) {
  const {
    triggerContent,
    triggerAriaLabel = "Toggle panel",
    panelContent,
    initialOpen = false,
    defaultWidthPx = 420,
    minWidthPx = 280,
    maxWidthPx = 800,
    onToggle,
    onResize,
    showTrigger = true
  } = options;
  let currentWidth = defaultWidthPx;
  let _open = initialOpen;
  const root = document.createElement("div");
  root.className = "ds-collapsible-panel";
  if (_open) root.classList.add("ds-collapsible-panel--open");
  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = "ds-collapsible-panel__trigger";
  trigger.setAttribute("aria-label", triggerAriaLabel);
  trigger.setAttribute("aria-expanded", String(_open));
  trigger.appendChild(triggerContent);
  const body = document.createElement("div");
  body.className = "ds-collapsible-panel__body";
  body.style.width = _open ? `${currentWidth}px` : "0px";
  const resizer = document.createElement("div");
  resizer.className = "ds-collapsible-panel__resizer";
  const content = document.createElement("div");
  content.className = "ds-collapsible-panel__content";
  content.appendChild(panelContent);
  body.appendChild(resizer);
  body.appendChild(content);
  if (showTrigger) root.appendChild(trigger);
  root.appendChild(body);
  function applyOpen(animate = true) {
    if (animate) body.classList.add("ds-collapsible-panel__body--animating");
    root.classList.toggle("ds-collapsible-panel--open", _open);
    trigger.setAttribute("aria-expanded", String(_open));
    body.style.width = _open ? `${currentWidth}px` : "0px";
    if (animate) {
      const onEnd = () => {
        body.classList.remove("ds-collapsible-panel__body--animating");
        body.removeEventListener("transitionend", onEnd);
      };
      body.addEventListener("transitionend", onEnd);
    }
    onToggle == null ? void 0 : onToggle(_open);
  }
  function open() {
    if (_open) return;
    _open = true;
    applyOpen();
  }
  function close() {
    if (!_open) return;
    _open = false;
    applyOpen();
  }
  function toggle() {
    _open = !_open;
    applyOpen();
  }
  trigger.addEventListener("click", (e) => {
    e.stopPropagation();
    toggle();
  });
  resizer.addEventListener("mousedown", (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = currentWidth;
    body.classList.remove("ds-collapsible-panel__body--animating");
    resizer.classList.add("ds-collapsible-panel__resizer--active");
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
    const onMove = (e2) => {
      const delta = startX - e2.clientX;
      const next = Math.max(minWidthPx, Math.min(maxWidthPx, startWidth + delta));
      currentWidth = next;
      body.style.width = `${next}px`;
      onResize == null ? void 0 : onResize(next);
    };
    const onUp = () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      resizer.classList.remove("ds-collapsible-panel__resizer--active");
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  });
  return {
    root,
    trigger,
    open,
    close,
    toggle,
    isOpen: () => _open,
    setWidth: (px) => {
      currentWidth = Math.max(minWidthPx, Math.min(maxWidthPx, px));
      if (_open) body.style.width = `${currentWidth}px`;
    },
    getWidth: () => currentWidth
  };
}

// src/utilities/contrastText.ts
var TEXT_CANDIDATES = [
  "#ffffff",
  "#e8e8e8",
  "#2d2d2d",
  "#1a1a1a"
];
function parseHex(hex) {
  const h = hex.replace(/^#/, "");
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16)
  ];
}
function srgbToLinear(c) {
  const s = c / 255;
  return s <= 0.04045 ? s / 12.92 : __pow((s + 0.055) / 1.055, 2.4);
}
function relativeLuminance(hex) {
  const [r, g, b] = parseHex(hex);
  return 0.2126 * srgbToLinear(r) + 0.7152 * srgbToLinear(g) + 0.0722 * srgbToLinear(b);
}
function contrastRatio(l1, l2) {
  const lighter = Math.max(l1, l2);
  const darker = Math.min(l1, l2);
  return (lighter + 0.05) / (darker + 0.05);
}
function contrastingTextColor(bgHex, candidates = TEXT_CANDIDATES) {
  const bgL = relativeLuminance(bgHex);
  let best = candidates[0];
  let bestRatio = 0;
  for (const candidate of candidates) {
    const ratio = contrastRatio(bgL, relativeLuminance(candidate));
    if (ratio > bestRatio) {
      bestRatio = ratio;
      best = candidate;
    }
  }
  return best;
}
function computeTextOnTokens(colors) {
  const tokens = {};
  for (const [name, hex] of Object.entries(colors)) {
    if (hex) tokens[`--ds-color-text-on-${name}`] = contrastingTextColor(hex);
  }
  return tokens;
}

// src/themeBuilder.ts
var THEME_SLOT_IDS = [
  "theme-primary",
  "theme-secondary",
  "theme-error",
  "theme-warning",
  "theme-info",
  "theme-success",
  "theme-white",
  "theme-grey-light-1",
  "theme-grey-light-2",
  "theme-grey-dark-1",
  "theme-grey-dark-2",
  "theme-black"
];
var THEME_SLOT_LABELS = {
  "theme-primary": "Primary",
  "theme-secondary": "Secondary",
  "theme-error": "Error",
  "theme-warning": "Warning",
  "theme-info": "Info",
  "theme-success": "Success",
  "theme-white": "White",
  "theme-grey-light-1": "Grey light 1",
  "theme-grey-light-2": "Grey light 2",
  "theme-grey-dark-1": "Grey dark 1",
  "theme-grey-dark-2": "Grey dark 2",
  "theme-black": "Black"
};
function hexToRgb(hex) {
  const h = hex.replace(/^#/, "");
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  return { r, g, b };
}
function hexToHsl(hex) {
  const { r, g, b } = hexToRgb(hex);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      default:
        h = ((r - g) / d + 4) / 6;
    }
  }
  return { h: h * 360, s, l };
}
function rgbToHex(r, g, b) {
  const toByte = (x) => Math.round(Math.max(0, Math.min(1, x)) * 255);
  return `#${toByte(r).toString(16).padStart(2, "0")}${toByte(g).toString(16).padStart(2, "0")}${toByte(b).toString(16).padStart(2, "0")}`;
}
function blendHex(hexA, hexB, weightB) {
  const a = hexToRgb(hexA);
  const b = hexToRgb(hexB);
  const r = (1 - weightB) * a.r + weightB * b.r;
  const g = (1 - weightB) * a.g + weightB * b.g;
  const bl = (1 - weightB) * a.b + weightB * b.b;
  return rgbToHex(r, g, bl);
}
function deriveGreysFromPrimary(primaryHex) {
  const tint = 0.04;
  const white = blendHex("#ffffff", primaryHex, tint);
  const light1 = blendHex("#e8e8e8", primaryHex, tint);
  const light2 = blendHex("#d0d0d0", primaryHex, tint);
  const dark1 = blendHex("#666666", primaryHex, tint);
  const dark2 = blendHex("#383838", primaryHex, tint);
  const black = blendHex("#000000", primaryHex, tint);
  return { white, light1, light2, dark1, dark2, black };
}
function deriveLighter(hex, amount = 0.4) {
  return blendHex(hex, "#ffffff", amount);
}
function deriveDarker(hex, amount = 0.3) {
  return blendHex(hex, "#000000", amount);
}
function updateDerivedSwatches() {
  var _a, _b;
  const primary = (_a = document.getElementById("theme-primary")) == null ? void 0 : _a.value;
  const secondary = (_b = document.getElementById("theme-secondary")) == null ? void 0 : _b.value;
  const setSwatch = (id, hex) => {
    const el = document.getElementById(id);
    if (el) el.style.backgroundColor = hex;
  };
  if (primary) {
    const p = normalizeHex(primary);
    setSwatch("theme-primary-lighter", deriveLighter(p));
    setSwatch("theme-primary-darker", deriveDarker(p));
  }
  if (secondary) {
    const s = normalizeHex(secondary);
    setSwatch("theme-secondary-lighter", deriveLighter(s));
    setSwatch("theme-secondary-darker", deriveDarker(s));
  }
}
function chroma(hex) {
  const { r, g, b } = hexToRgb(hex);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  return max - min;
}
function isGrey(hex, threshold = 0.12) {
  return chroma(hex) < threshold;
}
function normalizeHex(hex) {
  const h = hex.replace(/^#/, "");
  if (h.length === 6) return `#${h.toLowerCase()}`;
  if (h.length === 3)
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toLowerCase();
  return hex;
}
function hueDistance(h1, h2) {
  let d = Math.abs(h1 - h2);
  if (d > 180) d = 360 - d;
  return d;
}
function pickByHue(chromatic, targetHue, exclude) {
  let best = null;
  let bestScore = -1;
  for (const hex of chromatic) {
    if (exclude.has(hex)) continue;
    const { h, s } = hexToHsl(hex);
    const dist = hueDistance(h, targetHue);
    const score = s * (1 - dist / 180);
    if (score > bestScore) {
      bestScore = score;
      best = hex;
    }
  }
  return best;
}
function getComplementaryFromPalette(primaryHex, palette) {
  const chromatic = palette.colors.map((c) => c.hex).filter((hex) => !isGrey(hex));
  if (chromatic.length === 0) return null;
  const { h } = hexToHsl(primaryHex);
  const complementHue = (h + 180) % 360;
  return pickByHue(chromatic, complementHue, /* @__PURE__ */ new Set());
}
function applyCssFromSnapshot(snapshot) {
  const root = document.documentElement;
  const p = snapshot["theme-primary"];
  const s = snapshot["theme-secondary"];
  const e = snapshot["theme-error"];
  const w = snapshot["theme-warning"];
  const info = snapshot["theme-info"];
  const suc = snapshot["theme-success"];
  const white = snapshot["theme-white"];
  const light1 = snapshot["theme-grey-light-1"];
  const light2 = snapshot["theme-grey-light-2"];
  if (p) {
    root.style.setProperty("--ds-color-accent", p);
    root.style.setProperty("--ds-color-accent-hover", deriveDarker(p));
  }
  if (s) {
    root.style.setProperty("--ds-color-secondary", s);
    root.style.setProperty("--ds-color-secondary-hover", deriveDarker(s));
  }
  if (e) {
    root.style.setProperty("--ds-color-error", e);
    root.style.setProperty("--ds-color-error-hover", deriveDarker(e));
  }
  if (w) root.style.setProperty("--ds-color-warning", w);
  if (info) root.style.setProperty("--ds-color-info", info);
  if (suc) root.style.setProperty("--ds-color-success", suc);
  if (root.getAttribute("data-theme") !== "dark") {
    if (white) root.style.setProperty("--ds-color-bg-page", white);
    if (light1) root.style.setProperty("--ds-color-bg-surface", light1);
    if (light2) root.style.setProperty("--ds-color-bg-elevated", light2);
  }
  applyTextOnTokens(root, { p, s, e, w, info, suc });
}
function getThemeSnapshot() {
  const snapshot = {};
  for (const id of THEME_SLOT_IDS) {
    const input = document.getElementById(id);
    if (input == null ? void 0 : input.value) snapshot[id] = normalizeHex(input.value);
  }
  return snapshot;
}
function applyThemeFromSnapshot(snapshot) {
  for (const id of THEME_SLOT_IDS) {
    const hex = snapshot[id];
    if (!hex) continue;
    const input = document.getElementById(id);
    if ((input == null ? void 0 : input.type) === "color") {
      input.value = hex;
      const swatch = document.getElementById(`${id}-swatch`);
      if (swatch) swatch.style.backgroundColor = hex;
    }
  }
  applyThemeGreysToApp();
  applyThemeColorsToApp();
  updateDerivedSwatches();
}
function copyThemeHexToClipboard() {
  var _a, _b;
  const lines = THEME_SLOT_IDS.map((id) => {
    const input = document.getElementById(id);
    const value = (input == null ? void 0 : input.value) ? normalizeHex(input.value) : "";
    return `${THEME_SLOT_LABELS[id]}: ${value}`;
  });
  return (_b = (_a = navigator.clipboard) == null ? void 0 : _a.writeText(lines.join("\n"))) != null ? _b : Promise.resolve();
}
function applyThemeGreysToApp() {
  var _a, _b, _c;
  const root = document.documentElement;
  if (root.getAttribute("data-theme") === "dark") {
    root.style.removeProperty("--ds-color-bg-page");
    root.style.removeProperty("--ds-color-bg-surface");
    root.style.removeProperty("--ds-color-bg-elevated");
    return;
  }
  const white = (_a = document.getElementById("theme-white")) == null ? void 0 : _a.value;
  const light1 = (_b = document.getElementById("theme-grey-light-1")) == null ? void 0 : _b.value;
  const light2 = (_c = document.getElementById("theme-grey-light-2")) == null ? void 0 : _c.value;
  if (white) root.style.setProperty("--ds-color-bg-page", white);
  if (light1) root.style.setProperty("--ds-color-bg-surface", light1);
  if (light2) root.style.setProperty("--ds-color-bg-elevated", light2);
}
function applyTextOnTokens(root, colors) {
  const map = {};
  if (colors.p) map["accent"] = colors.p;
  if (colors.s) map["secondary"] = colors.s;
  if (colors.e) map["error"] = colors.e;
  if (colors.w) map["warning"] = colors.w;
  if (colors.info) map["info"] = colors.info;
  if (colors.suc) map["success"] = colors.suc;
  const tokens = computeTextOnTokens(map);
  for (const [prop, value] of Object.entries(tokens)) {
    root.style.setProperty(prop, value);
  }
}
function applyThemeColorsToApp() {
  const val = (id) => {
    var _a;
    return (_a = document.getElementById(id)) == null ? void 0 : _a.value;
  };
  const primary = val("theme-primary");
  const secondary = val("theme-secondary");
  const error = val("theme-error");
  const warning = val("theme-warning");
  const info = val("theme-info");
  const success = val("theme-success");
  const root = document.documentElement;
  if (primary) {
    const p = normalizeHex(primary);
    root.style.setProperty("--ds-color-accent", p);
    root.style.setProperty("--ds-color-accent-hover", deriveDarker(p));
  }
  if (secondary) {
    const s = normalizeHex(secondary);
    root.style.setProperty("--ds-color-secondary", s);
    root.style.setProperty("--ds-color-secondary-hover", deriveDarker(s));
  }
  if (error) {
    const e = normalizeHex(error);
    root.style.setProperty("--ds-color-error", e);
    root.style.setProperty("--ds-color-error-hover", deriveDarker(e));
  }
  if (warning) root.style.setProperty("--ds-color-warning", normalizeHex(warning));
  if (info) root.style.setProperty("--ds-color-info", normalizeHex(info));
  if (success) root.style.setProperty("--ds-color-success", normalizeHex(success));
  applyTextOnTokens(root, {
    p: primary ? normalizeHex(primary) : void 0,
    s: secondary ? normalizeHex(secondary) : void 0,
    e: error ? normalizeHex(error) : void 0,
    w: warning ? normalizeHex(warning) : void 0,
    info: info ? normalizeHex(info) : void 0,
    suc: success ? normalizeHex(success) : void 0
  });
}
function setThemeColor(slotId, hex) {
  const input = document.getElementById(slotId);
  if (!input || input.type !== "color") return;
  const value = normalizeHex(hex);
  input.value = value;
  input.dispatchEvent(new Event("input", { bubbles: true }));
  if (slotId === "theme-white" || slotId === "theme-grey-light-1" || slotId === "theme-grey-light-2") {
    applyThemeGreysToApp();
  }
  if (slotId === "theme-primary" || slotId === "theme-secondary" || slotId === "theme-error" || slotId === "theme-warning" || slotId === "theme-info" || slotId === "theme-success") {
    applyThemeColorsToApp();
  }
  if (slotId === "theme-primary" || slotId === "theme-secondary") {
    updateDerivedSwatches();
  }
}
function computeThemeSnapshotForPalette(palette) {
  var _a, _b, _c, _d, _e, _f;
  const colors = palette.colors.map((c) => c.hex);
  const chromatic = colors.filter((hex) => !isGrey(hex));
  const used = /* @__PURE__ */ new Set();
  const primary = (_a = pickByHue(chromatic, 220, used)) != null ? _a : chromatic.length > 0 ? chromatic[0] : "#0078d7";
  used.add(primary);
  const { h } = hexToHsl(primary);
  const complementHue = (h + 180) % 360;
  const secondary = (_d = (_c = (_b = pickByHue(chromatic, complementHue, used)) != null ? _b : pickByHue(chromatic, 30, used)) != null ? _c : chromatic.find((hex) => !used.has(hex))) != null ? _d : "#6b6b6b";
  used.add(secondary);
  const red = (_e = pickByHue(chromatic, 0, used)) != null ? _e : pickByHue(chromatic, 350, used);
  if (red) used.add(red);
  const yellow = pickByHue(chromatic, 55, used);
  if (yellow) used.add(yellow);
  const blue = pickByHue(chromatic, 220, used);
  if (blue) used.add(blue);
  const green = pickByHue(chromatic, 130, used);
  if (green) used.add(green);
  const fallbacks = [
    "#0078d7",
    "#6b6b6b",
    "#c0392b",
    "#f1c40f",
    "#3498db",
    "#27ae60"
  ];
  const semSlots = [
    "theme-primary",
    "theme-secondary",
    "theme-error",
    "theme-warning",
    "theme-info",
    "theme-success"
  ];
  const candidates = [
    primary,
    secondary,
    red != null ? red : fallbacks[2],
    yellow != null ? yellow : fallbacks[3],
    blue != null ? blue : fallbacks[4],
    green != null ? green : fallbacks[5]
  ];
  const usedSet = /* @__PURE__ */ new Set();
  const result = [];
  const pool = [...chromatic];
  for (let i = 0; i < 6; i++) {
    let c = candidates[i];
    if (usedSet.has(c)) {
      c = (_f = pool.find((x) => !usedSet.has(x))) != null ? _f : fallbacks[i];
    }
    usedSet.add(c);
    result.push(c);
  }
  const snapshot = {};
  semSlots.forEach((slot, i) => {
    snapshot[slot] = normalizeHex(result[i]);
  });
  const greys = deriveGreysFromPrimary(normalizeHex(result[0]));
  snapshot["theme-white"] = normalizeHex(greys.white);
  snapshot["theme-grey-light-1"] = normalizeHex(greys.light1);
  snapshot["theme-grey-light-2"] = normalizeHex(greys.light2);
  snapshot["theme-grey-dark-1"] = normalizeHex(greys.dark1);
  snapshot["theme-grey-dark-2"] = normalizeHex(greys.dark2);
  snapshot["theme-black"] = normalizeHex(greys.black);
  return snapshot;
}
function applyPaletteToThemeBuilder(palette) {
  applyThemeFromSnapshot(computeThemeSnapshotForPalette(palette));
}
function updateGreysFromPrimary(primaryHex) {
  const primaryInput = document.getElementById(
    "theme-primary"
  );
  const primary = primaryHex != null ? primaryHex : primaryInput == null ? void 0 : primaryInput.value;
  if (!primary) return;
  const greys = deriveGreysFromPrimary(normalizeHex(primary));
  setThemeColor("theme-white", greys.white);
  setThemeColor("theme-grey-light-1", greys.light1);
  setThemeColor("theme-grey-light-2", greys.light2);
  setThemeColor("theme-grey-dark-1", greys.dark1);
  setThemeColor("theme-grey-dark-2", greys.dark2);
  setThemeColor("theme-black", greys.black);
}

// src/flatUiPalettes.ts
var FLAT_UI_PALETTES = [
  {
    id: "defo",
    name: "Foundation",
    icon: "\u{1F3A8}",
    colors: [
      { name: "Turquoise", hex: "#1abc9c" },
      { name: "Green Sea", hex: "#16a085" },
      { name: "Sun Flower", hex: "#f1c40f" },
      { name: "Orange", hex: "#f39c12" },
      { name: "Emerald", hex: "#2ecc71" },
      { name: "Nephritis", hex: "#27ae60" },
      { name: "Carrot", hex: "#e67e22" },
      { name: "Pumpkin", hex: "#d35400" },
      { name: "Peter River", hex: "#3498db" },
      { name: "Belize Hole", hex: "#2980b9" },
      { name: "Alizarin", hex: "#e74c3c" },
      { name: "Pomegranate", hex: "#c0392b" },
      { name: "Amethyst", hex: "#9b59b6" },
      { name: "Wisteria", hex: "#8e44ad" },
      { name: "Clouds", hex: "#ecf0f1" },
      { name: "Silver", hex: "#bdc3c7" },
      { name: "Wet Asphalt", hex: "#34495e" },
      { name: "Midnight Blue", hex: "#2c3e50" },
      { name: "Concrete", hex: "#95a5a6" },
      { name: "Asbestos", hex: "#7f8c8d" }
    ]
  },
  {
    id: "aia",
    name: "AIA Signal",
    icon: "\u{1F6F0}\uFE0F",
    colors: [
      { name: "Command Night", hex: "#07171B" },
      { name: "Midnight Trunk", hex: "#081B20" },
      { name: "Deep Fabric", hex: "#092227" },
      { name: "Steel Teal", hex: "#0B2C30" },
      { name: "Mission Teal", hex: "#0E3D40" },
      { name: "Signal Cyan", hex: "#2E9EA1" },
      { name: "Apollo Mint", hex: "#52F3EC" },
      { name: "Aqua Relay", hex: "#58CDCF" },
      { name: "Operator Slate", hex: "#154243" },
      { name: "Graphite Current", hex: "#10393E" },
      { name: "Ocean Channel", hex: "#225D66" },
      { name: "Runway White", hex: "#FCFCFC" },
      { name: "Cloud White", hex: "#FDFDFD" },
      { name: "Neon Approval", hex: "#34D399" },
      { name: "Review Amber", hex: "#F59E0B" },
      { name: "Risk Red", hex: "#F87171" }
    ]
  },
  {
    id: "us",
    name: "Chalk",
    icon: "\u{1F58D}\uFE0F",
    colors: [
      { name: "Light Greenish Blue", hex: "#55efc4" },
      { name: "Faded Poster", hex: "#81ecec" },
      { name: "Green Darner Tail", hex: "#74b9ff" },
      { name: "Shy Moment", hex: "#a29bfe" },
      { name: "City Lights", hex: "#dfe6e9" },
      { name: "Mint Leaf", hex: "#00b894" },
      { name: "Robin's Egg Blue", hex: "#00cec9" },
      { name: "Electron Blue", hex: "#0984e3" },
      { name: "Exodus Fruit", hex: "#6c5ce7" },
      { name: "Soothing Breeze", hex: "#b2bec3" },
      { name: "Sour Lemon", hex: "#ffeaa7" },
      { name: "First Date", hex: "#fab1a0" },
      { name: "Pink Glamour", hex: "#ff7675" },
      { name: "Pico-8 Pink", hex: "#fd79a8" },
      { name: "American River", hex: "#636e72" },
      { name: "Bright Yarrow", hex: "#fdcb6e" },
      { name: "Orangeville", hex: "#e17055" },
      { name: "Chi-Gong", hex: "#d63031" },
      { name: "Prunus Avium", hex: "#e84393" },
      { name: "Dracula Orchid", hex: "#2d3436" }
    ]
  },
  {
    id: "au",
    name: "Ember",
    icon: "\u{1F525}",
    colors: [
      { name: "Beekeeper", hex: "#f6e58d" },
      { name: "Spiced Nectarine", hex: "#ffbe76" },
      { name: "Pink Glamour", hex: "#ff7979" },
      { name: "June Bud", hex: "#badc58" },
      { name: "Coastal Breeze", hex: "#dff9fb" },
      { name: "Turbo", hex: "#f9ca24" },
      { name: "Quince Jelly", hex: "#f0932b" },
      { name: "Carmine Pink", hex: "#eb4d4b" },
      { name: "Pure Apple", hex: "#6ab04c" },
      { name: "Hint of Ice Pack", hex: "#c7ecee" },
      { name: "Middle Blue", hex: "#7ed6df" },
      { name: "Heliotrope", hex: "#e056fd" },
      { name: "Exodus Fruit", hex: "#686de0" },
      { name: "Deep Koamaru", hex: "#30336b" },
      { name: "Soaring Eagle", hex: "#95afc0" },
      { name: "Greenland Green", hex: "#22a6b3" },
      { name: "Steel Pink", hex: "#be2edd" },
      { name: "Blurple", hex: "#4834d4" },
      { name: "Deep Cove", hex: "#130f40" },
      { name: "Wizard Grey", hex: "#535c68" }
    ]
  },
  {
    id: "gb",
    name: "Berry",
    icon: "\u{1FAD0}",
    colors: [
      { name: "Pomegranate", hex: "#eb3b5a" },
      { name: "Very Berry", hex: "#fa8231" },
      { name: "Rose", hex: "#f7b731" },
      { name: "Beniukon Bronze", hex: "#2bcbba" },
      { name: "Maximum Blue Green", hex: "#0fb9b1" },
      { name: "Desire", hex: "#3867d6" },
      { name: "Boyzone", hex: "#8854d0" },
      { name: "Lime Soap", hex: "#26de81" },
      { name: "Algal Fuel", hex: "#20bf6b" },
      { name: "Reef Encounter", hex: "#0fb9b1" },
      { name: "Cyanite", hex: "#2bcbba" },
      { name: "Blue Curacao", hex: "#4b7bec" },
      { name: "Royal Blue", hex: "#3867d6" },
      { name: "Grey Porcelain", hex: "#778ca3" },
      { name: "Blue Horizon", hex: "#a5b1c2" },
      { name: "Orange Hibiscus", hex: "#fd9644" },
      { name: "Flame", hex: "#fc5c65" },
      { name: "Red Orange", hex: "#eb3b5a" },
      { name: "Violet", hex: "#8854d0" }
    ]
  },
  {
    id: "ca",
    name: "Ice",
    icon: "\u{1F9CA}",
    colors: [
      { name: "Jigglypuff", hex: "#ff6b81" },
      { name: "Casandora Yellow", hex: "#ff9f43" },
      { name: "Pastel Red", hex: "#ff6b6b" },
      { name: "Megaman", hex: "#48dbfb" },
      { name: "Wild Caribbean Green", hex: "#1dd1a1" },
      { name: "Li\xE1n H\xF3ng Lotus Pink", hex: "#ff9ff3" },
      { name: "Double Dragon Skin", hex: "#feca57" },
      { name: "Amour", hex: "#ee5253" },
      { name: "Cyanite", hex: "#0abde3" },
      { name: "Dark Mountain Meadow", hex: "#10ac84" },
      { name: "Jade Dust", hex: "#00d2d3" },
      { name: "Joust Blue", hex: "#54a0ff" },
      { name: "Nasu Purple", hex: "#5f27cd" },
      { name: "Light Blue Ballerina", hex: "#c8d6e5" },
      { name: "Fuel Town", hex: "#576574" },
      { name: "Aqua Velvet", hex: "#01a3a4" },
      { name: "Bleu De France", hex: "#2e86de" },
      { name: "Bluebell", hex: "#341f97" },
      { name: "Storm Petrel", hex: "#8395a7" },
      { name: "Imperial Primer", hex: "#222f3e" }
    ]
  },
  {
    id: "cn",
    name: "Clay",
    icon: "\u{1FAD9}",
    colors: [
      { name: "Golden Sand", hex: "#fdcb6e" },
      { name: "Coral", hex: "#ff7675" },
      { name: "Wild Watermelon", hex: "#fd79a8" },
      { name: "Sizzling Red", hex: "#e17055" },
      { name: "Pink Glamour", hex: "#fd79a8" },
      { name: "Biscay", hex: "#2d3436" },
      { name: "Peach Orange", hex: "#e17055" },
      { name: "Chilean Fire", hex: "#e17055" },
      { name: "Pico-8 Pink", hex: "#fd79a8" },
      { name: "American River", hex: "#636e72" },
      { name: "Dracula Orchid", hex: "#2d3436" },
      { name: "Soothing Breeze", hex: "#b2bec3" },
      { name: "City Lights", hex: "#dfe6e9" },
      { name: "Electron Blue", hex: "#0984e3" },
      { name: "Exodus Fruit", hex: "#6c5ce7" },
      { name: "Mint Leaf", hex: "#00b894" },
      { name: "Robin's Egg Blue", hex: "#00cec9" },
      { name: "First Date", hex: "#fab1a0" },
      { name: "Orangeville", hex: "#e17055" },
      { name: "Chi-Gong", hex: "#d63031" }
    ]
  },
  {
    id: "nl",
    name: "Meadow",
    icon: "\u{1F33F}",
    colors: [
      { name: "Sunflower", hex: "#ffc312" },
      { name: "Energos", hex: "#c4e538" },
      { name: "Android Green", hex: "#a3cb38" },
      { name: "Mediterranean Sea", hex: "#12cbc4" },
      { name: "Merchant Marine Blue", hex: "#1289a7" },
      { name: "Pico-8 Pink", hex: "#fd79a8" },
      { name: "Lavender Rose", hex: "#f8b500" },
      { name: "Bara Red", hex: "#ed4c67" },
      { name: "Radical Red", hex: "#ea2027" },
      { name: "Red Pigment", hex: "#eb3b5a" },
      { name: "Turkish Aqua", hex: "#006266" },
      { name: "Circumorbital Ring", hex: "#5758bb" },
      { name: "20000 Leagues Under the Sea", hex: "#1b1464" },
      { name: "Protoss Pylon", hex: "#00a8ff" },
      { name: "Periwinkle", hex: "#9c88ff" },
      { name: "Rise-N-Shine", hex: "#fbc531" },
      { name: "Download Progress", hex: "#4cd137" },
      { name: "Seabrook", hex: "#44bd32" },
      { name: "Violet", hex: "#8c7ae6" },
      { name: "Deep Koamaru", hex: "#273c75" }
    ]
  },
  {
    id: "fr",
    name: "Seaside",
    icon: "\u{1F30A}",
    colors: [
      { name: "Flat Flesh", hex: "#fad390" },
      { name: "Melon Melody", hex: "#f8c291" },
      { name: "Livid", hex: "#6c5ce7" },
      { name: "Spray", hex: "#82ccdd" },
      { name: "Paradise Green", hex: "#b8e994" },
      { name: "Squash Blossom", hex: "#f6b93b" },
      { name: "Mandarin Red", hex: "#e55039" },
      { name: "Azraq Blue", hex: "#4a69bd" },
      { name: "Dupain", hex: "#60a3bc" },
      { name: "Aurora Green", hex: "#78e08f" },
      { name: "Iceland Poppy", hex: "#fa983a" },
      { name: "Tomato Red", hex: "#eb2f06" },
      { name: "Yu\xE8 Gu\u0101ng L\xE1n Blue", hex: "#1e3799" },
      { name: "Good Samaritan", hex: "#3c6382" },
      { name: "Waterfall", hex: "#38ada9" },
      { name: "Carrot Orange", hex: "#e58e26" },
      { name: "Jalapeno Red", hex: "#b71540" },
      { name: "Dark Sapphire", hex: "#0c2461" },
      { name: "Forest Blues", hex: "#0a3d62" },
      { name: "Reef Encounter", hex: "#079992" }
    ]
  },
  {
    id: "de",
    name: "Slate",
    icon: "\u{1FAA8}",
    colors: [
      { name: "Polar Night", hex: "#2c3e50" },
      { name: "Pico-8 Pink", hex: "#fd79a8" },
      { name: "Pink Glamour", hex: "#ff7675" },
      { name: "Exodus Fruit", hex: "#6c5ce7" },
      { name: "Electron Blue", hex: "#0984e3" },
      { name: "Soothing Breeze", hex: "#b2bec3" },
      { name: "American River", hex: "#636e72" },
      { name: "Dracula Orchid", hex: "#2d3436" },
      { name: "Sour Lemon", hex: "#ffeaa7" },
      { name: "Bright Yarrow", hex: "#fdcb6e" },
      { name: "First Date", hex: "#fab1a0" },
      { name: "Orangeville", hex: "#e17055" },
      { name: "Chi-Gong", hex: "#d63031" },
      { name: "City Lights", hex: "#dfe6e9" },
      { name: "Mint Leaf", hex: "#00b894" },
      { name: "Robin's Egg Blue", hex: "#00cec9" },
      { name: "Green Darner Tail", hex: "#74b9ff" },
      { name: "Shy Moment", hex: "#a29bfe" },
      { name: "Prunus Avium", hex: "#e84393" },
      { name: "Light Greenish Blue", hex: "#55efc4" }
    ]
  },
  {
    id: "in",
    name: "Spice",
    icon: "\u{1F336}\uFE0F",
    colors: [
      { name: "Orchid Orange", hex: "#fea47f" },
      { name: "Spiro Disco Ball", hex: "#25ccf7" },
      { name: "Honey Glow", hex: "#eab543" },
      { name: "Sweet Garden", hex: "#55e6c1" },
      { name: "Falling Star", hex: "#cad3c8" },
      { name: "Rich Garden", hex: "#00b894" },
      { name: "Keppel", hex: "#58b19f" },
      { name: "Spray", hex: "#81ecec" },
      { name: "Paradise Pink", hex: "#e84393" },
      { name: "Bara Red", hex: "#ff6b6b" },
      { name: "Peach", hex: "#fdcb6e" },
      { name: "Pink Glamour", hex: "#fd79a8" },
      { name: "Rogue Pink", hex: "#fd79a8" },
      { name: "Squeeze", hex: "#778ca3" },
      { name: "Blue Curacao", hex: "#3742fa" },
      { name: "Pomegranate", hex: "#eb3b5a" },
      { name: "Violet", hex: "#a29bfe" },
      { name: "Light Indigo", hex: "#6c5ce7" },
      { name: "Bright Yarrow", hex: "#fdcb6e" },
      { name: "Deep Koamaru", hex: "#2d3436" }
    ]
  },
  {
    id: "ru",
    name: "Amber",
    icon: "\u{1F36F}",
    colors: [
      { name: "Sunflower", hex: "#ffc312" },
      { name: "Energos", hex: "#c4e538" },
      { name: "Android Green", hex: "#a3cb38" },
      { name: "Mediterranean Sea", hex: "#12cbc4" },
      { name: "Merchant Marine Blue", hex: "#1289a7" },
      { name: "Lavender Rose", hex: "#f8b500" },
      { name: "Bara Red", hex: "#ed4c67" },
      { name: "Radical Red", hex: "#ea2027" },
      { name: "Red Pigment", hex: "#eb3b5a" },
      { name: "Turkish Aqua", hex: "#006266" },
      { name: "Circumorbital Ring", hex: "#5758bb" },
      { name: "20000 Leagues Under the Sea", hex: "#1b1464" },
      { name: "Protoss Pylon", hex: "#00a8ff" },
      { name: "Periwinkle", hex: "#9c88ff" },
      { name: "Rise-N-Shine", hex: "#fbc531" },
      { name: "Download Progress", hex: "#4cd137" },
      { name: "Seabrook", hex: "#44bd32" },
      { name: "Violet", hex: "#8c7ae6" },
      { name: "Deep Koamaru", hex: "#273c75" },
      { name: "Jackson Purple", hex: "#40407a" }
    ]
  },
  {
    id: "es",
    name: "Adobe",
    icon: "\u{1F9F1}",
    colors: [
      { name: "Jackson Purple", hex: "#40407a" },
      { name: "C64 Purple", hex: "#706fd3" },
      { name: "Swan White", hex: "#f7f1e3" },
      { name: "Summer Sky", hex: "#34ace0" },
      { name: "Celestial Green", hex: "#33d9b2" },
      { name: "Hot Stone", hex: "#aaa69d" },
      { name: "Devil Blue", hex: "#227093" },
      { name: "Palm Springs Splash", hex: "#218c74" },
      { name: "Fluorescent Red", hex: "#ff5252" },
      { name: "Synthetic Pumpkin", hex: "#ff793f" },
      { name: "Crocodile Tooth", hex: "#d1ccc0" },
      { name: "Mandarin Sorbet", hex: "#ffb142" },
      { name: "Spiced Butternut", hex: "#ffda79" },
      { name: "Eye of Newt", hex: "#b33939" },
      { name: "Chilean Fire", hex: "#cd6133" },
      { name: "Grey Porcelain", hex: "#84817a" },
      { name: "Alameda Ochre", hex: "#cc8e35" },
      { name: "Desert", hex: "#ccae62" },
      { name: "Blue Night", hex: "#2c2c54" },
      { name: "Lynx White", hex: "#f5f6fa" }
    ]
  },
  {
    id: "se",
    name: "Frost",
    icon: "\u2744\uFE0F",
    colors: [
      { name: "High Blue", hex: "#6c5ce7" },
      { name: "Soft Purple", hex: "#a29bfe" },
      { name: "Pink Glamour", hex: "#fd79a8" },
      { name: "Exodus Fruit", hex: "#6c5ce7" },
      { name: "Bright Yarrow", hex: "#fdcb6e" },
      { name: "Sour Lemon", hex: "#ffeaa7" },
      { name: "First Date", hex: "#fab1a0" },
      { name: "Orangeville", hex: "#e17055" },
      { name: "Pico-8 Pink", hex: "#fd79a8" },
      { name: "Chi-Gong", hex: "#d63031" },
      { name: "Prunus Avium", hex: "#e84393" },
      { name: "Dracula Orchid", hex: "#2d3436" },
      { name: "American River", hex: "#636e72" },
      { name: "Soothing Breeze", hex: "#b2bec3" },
      { name: "City Lights", hex: "#dfe6e9" },
      { name: "Mint Leaf", hex: "#00b894" },
      { name: "Robin's Egg Blue", hex: "#00cec9" },
      { name: "Electron Blue", hex: "#0984e3" },
      { name: "Green Darner Tail", hex: "#74b9ff" },
      { name: "Light Greenish Blue", hex: "#55efc4" }
    ]
  },
  {
    id: "tr",
    name: "Sorbet",
    icon: "\u{1F367}",
    colors: [
      { name: "Bright Lilac", hex: "#cd84f1" },
      { name: "Pretty Please", hex: "#ffcccc" },
      { name: "Light Red", hex: "#ff6b6b" },
      { name: "Mandarin Sorbet", hex: "#ffb142" },
      { name: "Unmellow Yellow", hex: "#fffa65" },
      { name: "Light Purple", hex: "#c56cf0" },
      { name: "Young Salmon", hex: "#ffb8b8" },
      { name: "Red Orange", hex: "#ff3838" },
      { name: "Royal Blue", hex: "#3742fa" },
      { name: "Grey Porcelain", hex: "#aaa69d" },
      { name: "Pink Shadow", hex: "#ff9ff3" },
      { name: "Synthetic Pumpkin", hex: "#ff793f" },
      { name: "Honey Glow", hex: "#eab543" },
      { name: "Squash Blossom", hex: "#f6b93b" },
      { name: "Steel Pink", hex: "#be2edd" },
      { name: "Blurple", hex: "#4834d4" },
      { name: "Circumorbital Ring", hex: "#5758bb" },
      { name: "Protoss Pylon", hex: "#00a8ff" },
      { name: "Periwinkle", hex: "#9c88ff" },
      { name: "Download Progress", hex: "#4cd137" }
    ]
  },
  {
    id: "sunset",
    name: "Sunset",
    icon: "\u{1F305}",
    colors: [
      { name: "Peach", hex: "#ff9a8b" },
      { name: "Coral", hex: "#ff7e5f" },
      { name: "Salmon", hex: "#fa8072" },
      { name: "Tomato", hex: "#ff6347" },
      { name: "Tangerine", hex: "#ff9966" },
      { name: "Gold", hex: "#ffd700" },
      { name: "Amber", hex: "#ffbf00" },
      { name: "Marigold", hex: "#eaa221" },
      { name: "Rust", hex: "#b7410e" },
      { name: "Terracotta", hex: "#e2725b" },
      { name: "Dusty Rose", hex: "#dcae96" },
      { name: "Blush", hex: "#de98ab" },
      { name: "Lavender Blush", hex: "#fff0f5" },
      { name: "Mauve", hex: "#e0b0ff" },
      { name: "Plum", hex: "#dda0dd" },
      { name: "Slate", hex: "#708090" },
      { name: "Warm Grey", hex: "#8b7355" },
      { name: "Sand", hex: "#c2b280" },
      { name: "Cream", hex: "#fffdd0" },
      { name: "Ivory", hex: "#fffff0" }
    ]
  },
  {
    id: "forest",
    name: "Forest",
    icon: "\u{1F332}",
    colors: [
      { name: "Forest Green", hex: "#228b22" },
      { name: "Hunter", hex: "#355e3b" },
      { name: "Sage", hex: "#9dc183" },
      { name: "Moss", hex: "#8a9a5b" },
      { name: "Fern", hex: "#71bc78" },
      { name: "Mint", hex: "#98ff98" },
      { name: "Seafoam", hex: "#93e9be" },
      { name: "Jade", hex: "#00a86b" },
      { name: "Pine", hex: "#01796f" },
      { name: "Olive", hex: "#808000" },
      { name: "Lime", hex: "#32cd32" },
      { name: "Chartreuse", hex: "#7fff00" },
      { name: "Leaf", hex: "#4a7c59" },
      { name: "Bark", hex: "#654321" },
      { name: "Earth", hex: "#8b4513" },
      { name: "Stone", hex: "#928e85" },
      { name: "Fog", hex: "#dcdcdc" },
      { name: "Mist", hex: "#e6e6fa" },
      { name: "Frost", hex: "#e8f4ea" },
      { name: "Snow", hex: "#fffafa" }
    ]
  },
  {
    id: "ocean",
    name: "Ocean",
    icon: "\u{1F30A}",
    colors: [
      { name: "Aqua", hex: "#00ffff" },
      { name: "Teal", hex: "#008080" },
      { name: "Cyan", hex: "#00bcd4" },
      { name: "Turquoise", hex: "#40e0d0" },
      { name: "Marine", hex: "#042e60" },
      { name: "Navy", hex: "#000080" },
      { name: "Sapphire", hex: "#0f52ba" },
      { name: "Cobalt", hex: "#0047ab" },
      { name: "Sky", hex: "#87ceeb" },
      { name: "Powder Blue", hex: "#b0e0e6" },
      { name: "Ice", hex: "#d4f1f4" },
      { name: "Wave", hex: "#7eb6b8" },
      { name: "Lagoon", hex: "#48c9b0" },
      { name: "Deep Sea", hex: "#1a535c" },
      { name: "Tidal", hex: "#3d5a80" },
      { name: "Horizon", hex: "#98c1d9" },
      { name: "Foam", hex: "#e8f4f8" },
      { name: "Pearl", hex: "#e2e8e9" },
      { name: "Driftwood", hex: "#b8a99a" },
      { name: "Sand", hex: "#f4e4bc" }
    ]
  },
  {
    id: "neon",
    name: "Neon",
    icon: "\u2728",
    colors: [
      { name: "Hot Pink", hex: "#ff69b4" },
      { name: "Electric Pink", hex: "#ff10f0" },
      { name: "Magenta", hex: "#ff00ff" },
      { name: "Lime", hex: "#ccff00" },
      { name: "Electric Lime", hex: "#bfff00" },
      { name: "Cyan", hex: "#00ffff" },
      { name: "Laser Lemon", hex: "#ffff66" },
      { name: "Orange", hex: "#ff6600" },
      { name: "Neon Orange", hex: "#ff9f43" },
      { name: "Yellow", hex: "#ffff00" },
      { name: "Green", hex: "#39ff14" },
      { name: "Blue", hex: "#0047ab" },
      { name: "Purple", hex: "#bf00ff" },
      { name: "Violet", hex: "#8f00ff" },
      { name: "Red", hex: "#ff073a" },
      { name: "Coral", hex: "#ff6f61" },
      { name: "Mint", hex: "#98ff98" },
      { name: "Aqua", hex: "#13e8e8" },
      { name: "White", hex: "#ffffff" },
      { name: "Black", hex: "#0d0d0d" }
    ]
  },
  {
    id: "muted",
    name: "Muted",
    icon: "\u{1F3AD}",
    colors: [
      { name: "Dusty Blue", hex: "#6b8cae" },
      { name: "Sage", hex: "#9caf88" },
      { name: "Mauve", hex: "#b39eb5" },
      { name: "Taupe", hex: "#a09080" },
      { name: "Slate", hex: "#708090" },
      { name: "Dusty Rose", hex: "#c9a9a6" },
      { name: "Sage Green", hex: "#87ae73" },
      { name: "Muted Teal", hex: "#5f9ea0" },
      { name: "Clay", hex: "#b87333" },
      { name: "Stone", hex: "#928e85" },
      { name: "Sand", hex: "#c2b280" },
      { name: "Blush", hex: "#de98ab" },
      { name: "Lavender Grey", hex: "#c4b5d0" },
      { name: "Dove", hex: "#bebebe" },
      { name: "Fog", hex: "#dcdcdc" },
      { name: "Charcoal", hex: "#36454f" },
      { name: "Graphite", hex: "#383838" },
      { name: "Smoke", hex: "#738276" },
      { name: "Parchment", hex: "#f0e6d3" },
      { name: "Cream", hex: "#fffdd0" }
    ]
  },
  {
    id: "desert",
    name: "Desert",
    icon: "\u{1F3DC}\uFE0F",
    colors: [
      { name: "Sand", hex: "#c2b280" },
      { name: "Dune", hex: "#e0c9a0" },
      { name: "Sienna", hex: "#a0522d" },
      { name: "Terracotta", hex: "#e2725b" },
      { name: "Adobe", hex: "#bd6b3a" },
      { name: "Ochre", hex: "#cc7722" },
      { name: "Amber", hex: "#ffbf00" },
      { name: "Gold", hex: "#ffd700" },
      { name: "Mustard", hex: "#ffdb58" },
      { name: "Camel", hex: "#c19a6b" },
      { name: "Tan", hex: "#d2b48c" },
      { name: "Wheat", hex: "#f5deb3" },
      { name: "Blanched Almond", hex: "#ffebcd" },
      { name: "Papaya", hex: "#ffefd5" },
      { name: "Bisque", hex: "#ffe4c4" },
      { name: "Rust", hex: "#b7410e" },
      { name: "Copper", hex: "#b87333" },
      { name: "Stone", hex: "#928e85" },
      { name: "Dust", hex: "#968c83" },
      { name: "Sandstorm", hex: "#ecd540" }
    ]
  },
  {
    id: "noir",
    name: "Noir",
    icon: "\u{1F3A9}",
    colors: [
      { name: "Black", hex: "#0d0d0d" },
      { name: "Charcoal", hex: "#36454f" },
      { name: "Graphite", hex: "#383838" },
      { name: "Slate", hex: "#708090" },
      { name: "Gunmetal", hex: "#2a3439" },
      { name: "Ink", hex: "#1c1c1c" },
      { name: "Obsidian", hex: "#0b0b0b" },
      { name: "Silver", hex: "#c0c0c0" },
      { name: "Platinum", hex: "#e5e4e2" },
      { name: "Smoke", hex: "#738276" },
      { name: "Ash", hex: "#b2beb5" },
      { name: "Pewter", hex: "#8b8680" },
      { name: "Crimson", hex: "#dc143c" },
      { name: "Gold", hex: "#ffd700" },
      { name: "Ivory", hex: "#fffff0" },
      { name: "Off White", hex: "#faf9f6" },
      { name: "Steel", hex: "#71797e" },
      { name: "Iron", hex: "#4a4a4a" },
      { name: "Shadow", hex: "#2f2f2f" },
      { name: "White", hex: "#fafafa" }
    ]
  },
  {
    id: "spring",
    name: "Spring",
    icon: "\u{1F338}",
    colors: [
      { name: "Blossom", hex: "#ffb7c5" },
      { name: "Peach", hex: "#ffcba4" },
      { name: "Mint", hex: "#98ff98" },
      { name: "Lavender", hex: "#e6e6fa" },
      { name: "Lilac", hex: "#c8a2c8" },
      { name: "Sage", hex: "#9dc183" },
      { name: "Pale Green", hex: "#98fb98" },
      { name: "Sky Blue", hex: "#87ceeb" },
      { name: "Butter", hex: "#fffacd" },
      { name: "Rose", hex: "#ff007f" },
      { name: "Coral", hex: "#ff7f50" },
      { name: "Apricot", hex: "#fbceb1" },
      { name: "Thistle", hex: "#d8bfd8" },
      { name: "Honeydew", hex: "#f0fff0" },
      { name: "Ivory", hex: "#fffff0" },
      { name: "Pink", hex: "#ffc0cb" },
      { name: "Yellow", hex: "#fff44f" },
      { name: "Cream", hex: "#fffdd0" },
      { name: "Snow", hex: "#fffafa" },
      { name: "White", hex: "#ffffff" }
    ]
  },
  {
    id: "lavender",
    name: "Lavender",
    icon: "\u{1F49C}",
    colors: [
      { name: "Lavender", hex: "#e6e6fa" },
      { name: "Lilac", hex: "#c8a2c8" },
      { name: "Plum", hex: "#dda0dd" },
      { name: "Violet", hex: "#ee82ee" },
      { name: "Orchid", hex: "#da70d6" },
      { name: "Mauve", hex: "#e0b0ff" },
      { name: "Thistle", hex: "#d8bfd8" },
      { name: "Wisteria", hex: "#c9a0dc" },
      { name: "Amethyst", hex: "#9966cc" },
      { name: "Purple", hex: "#800080" },
      { name: "Indigo", hex: "#4b0082" },
      { name: "Periwinkle", hex: "#ccccff" },
      { name: "Lavender Blush", hex: "#fff0f5" },
      { name: "Misty Rose", hex: "#ffe4e1" },
      { name: "Snow", hex: "#fffafa" },
      { name: "Ghost White", hex: "#f8f8ff" },
      { name: "Silver", hex: "#c0c0c0" },
      { name: "Grey", hex: "#808080" },
      { name: "Slate", hex: "#708090" },
      { name: "White", hex: "#fafafa" }
    ]
  },
  {
    id: "coral",
    name: "Coral",
    icon: "\u{1FAB8}",
    colors: [
      { name: "Coral", hex: "#ff7f50" },
      { name: "Salmon", hex: "#fa8072" },
      { name: "Light Salmon", hex: "#ffa07a" },
      { name: "Peach", hex: "#ffcba4" },
      { name: "Blush", hex: "#de98ab" },
      { name: "Rose", hex: "#ff007f" },
      { name: "Hot Pink", hex: "#ff69b4" },
      { name: "Deep Pink", hex: "#ff1493" },
      { name: "Tomato", hex: "#ff6347" },
      { name: "Orange Red", hex: "#ff4500" },
      { name: "Tangerine", hex: "#ff9966" },
      { name: "Apricot", hex: "#fbceb1" },
      { name: "Misty Rose", hex: "#ffe4e1" },
      { name: "Lavender Blush", hex: "#fff0f5" },
      { name: "Seashell", hex: "#fff5ee" },
      { name: "Teal", hex: "#008080" },
      { name: "Turquoise", hex: "#40e0d0" },
      { name: "Sand", hex: "#c2b280" },
      { name: "Cream", hex: "#fffdd0" },
      { name: "White", hex: "#fffafa" }
    ]
  }
];

// src/renderPalettes.ts
var swatchPopover = null;
var swatchPopoverClose = null;
function getOrCreateSwatchPopover() {
  if (swatchPopover) return swatchPopover;
  const pop = document.createElement("div");
  pop.className = "dp-swatch-popover";
  pop.setAttribute("hidden", "");
  pop.setAttribute("role", "menu");
  document.body.appendChild(pop);
  swatchPopover = pop;
  return pop;
}
function showSwatchMenu(hex, anchorRect) {
  const pop = getOrCreateSwatchPopover();
  pop.innerHTML = "";
  pop.removeAttribute("hidden");
  const title = document.createElement("div");
  title.className = "dp-swatch-popover-title";
  title.textContent = hex;
  pop.appendChild(title);
  for (const slotId of THEME_SLOT_IDS) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dp-swatch-popover-button";
    btn.textContent = `Set as ${THEME_SLOT_LABELS[slotId]}`;
    btn.setAttribute("role", "menuitem");
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      setThemeColor(slotId, hex);
      closeSwatchMenu();
    });
    pop.appendChild(btn);
  }
  const copyBtn = document.createElement("button");
  copyBtn.type = "button";
  copyBtn.className = "dp-swatch-popover-button";
  copyBtn.textContent = "Copy hex";
  copyBtn.setAttribute("role", "menuitem");
  copyBtn.addEventListener("click", (e) => {
    var _a;
    e.stopPropagation();
    (_a = navigator.clipboard) == null ? void 0 : _a.writeText(hex).catch(() => {
    });
    closeSwatchMenu();
  });
  pop.appendChild(copyBtn);
  pop.style.left = `${anchorRect.left}px`;
  pop.style.top = `${anchorRect.bottom + 4}px`;
  function close() {
    pop.setAttribute("hidden", "");
    document.removeEventListener("click", close);
    swatchPopoverClose = null;
  }
  swatchPopoverClose = close;
  setTimeout(() => document.addEventListener("click", close), 0);
}
function closeSwatchMenu() {
  swatchPopoverClose == null ? void 0 : swatchPopoverClose();
}
function renderSwatches(parent, palette) {
  const swatches = document.createElement("div");
  swatches.className = "dp-palette-swatches";
  swatches.setAttribute("role", "list");
  for (const color of palette.colors) {
    const item = document.createElement("div");
    item.className = "dp-palette-swatch";
    item.setAttribute("role", "listitem");
    item.style.backgroundColor = color.hex;
    item.title = `${color.name} \u2014 ${color.hex} (click for options)`;
    const r = parseInt(color.hex.slice(1, 3), 16) / 255;
    const g = parseInt(color.hex.slice(3, 5), 16) / 255;
    const b = parseInt(color.hex.slice(5, 7), 16) / 255;
    const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    item.classList.toggle("dp-palette-swatch--dark", lum < 0.4);
    item.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      showSwatchMenu(color.hex, item.getBoundingClientRect());
    });
    swatches.appendChild(item);
  }
  parent.appendChild(swatches);
}
function renderPaletteDisplay(displayEl, palette) {
  displayEl.innerHTML = "";
  renderSwatches(displayEl, palette);
}
function renderPalettes(container, opts = {}) {
  container.innerHTML = "";
  container.classList.add("design-playground-palettes");
  const selectRow = document.createElement("div");
  selectRow.className = "dp-palette-select-row";
  const select = document.createElement("select");
  select.id = "dp-palette-select";
  select.className = "dp-palette-select";
  select.setAttribute("aria-label", "Choose color palette");
  const sortedPalettes = [...FLAT_UI_PALETTES].sort((a, b) => {
    if (a.name === "Foundation") return -1;
    if (b.name === "Foundation") return 1;
    return a.name.localeCompare(b.name, void 0, { sensitivity: "base" });
  });
  for (const palette of sortedPalettes) {
    const option = document.createElement("option");
    option.value = palette.id;
    option.textContent = palette.icon ? `${palette.icon} ${palette.name}` : palette.name;
    select.appendChild(option);
  }
  if (opts.initialPaletteId) {
    const exists = sortedPalettes.some((p) => p.id === opts.initialPaletteId);
    if (exists) select.value = opts.initialPaletteId;
  }
  selectRow.appendChild(select);
  container.appendChild(selectRow);
  const display = document.createElement("div");
  display.className = "dp-palette-display";
  container.appendChild(display);
  function showSwatches() {
    const selected = FLAT_UI_PALETTES.find((p) => p.id === select.value);
    if (selected) renderPaletteDisplay(display, selected);
  }
  function onUserChange() {
    var _a;
    const selected = FLAT_UI_PALETTES.find((p) => p.id === select.value);
    if (selected) {
      renderPaletteDisplay(display, selected);
      applyPaletteToThemeBuilder(selected);
      (_a = opts.onPaletteChange) == null ? void 0 : _a.call(opts, selected.id);
    }
  }
  select.addEventListener("change", onUserChange);
  if (opts.initialPaletteId) {
    showSwatches();
  } else {
    onUserChange();
  }
}

// src/themeBuilderPage.ts
var ICON_COMPLEMENT = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/></svg>';
var SEMANTIC_SLOT_IDS = [
  "theme-primary",
  "theme-secondary",
  "theme-error",
  "theme-warning",
  "theme-info",
  "theme-success"
];
var GREY_SLOT_IDS = [
  "theme-white",
  "theme-grey-light-1",
  "theme-grey-light-2",
  "theme-grey-dark-1",
  "theme-grey-dark-2",
  "theme-black"
];
var DEFAULT_THEME = {
  "theme-primary": "#0078d7",
  "theme-secondary": "#6b6b6b",
  "theme-error": "#ff6b6b",
  "theme-warning": "#ff9800",
  "theme-info": "#3498db",
  "theme-success": "#4caf50",
  "theme-white": "#ffffff",
  "theme-grey-light-1": "#f2f2f2",
  "theme-grey-light-2": "#d0d0d0",
  "theme-grey-dark-1": "#666666",
  "theme-grey-dark-2": "#383838",
  "theme-black": "#000000"
};
function buildColorRow(slotId, trailingAction, onThemeChange) {
  var _a, _b;
  const row = document.createElement("div");
  row.className = "tb-color-row";
  const swatch = document.createElement("span");
  swatch.id = `${slotId}-swatch`;
  swatch.className = "tb-swatch";
  swatch.style.backgroundColor = (_a = DEFAULT_THEME[slotId]) != null ? _a : "#cccccc";
  row.appendChild(swatch);
  const label = document.createElement("label");
  label.className = "tb-color-label";
  label.htmlFor = slotId;
  label.textContent = THEME_SLOT_LABELS[slotId];
  row.appendChild(label);
  const input = document.createElement("input");
  input.type = "color";
  input.id = slotId;
  input.className = "tb-color-input";
  input.value = (_b = DEFAULT_THEME[slotId]) != null ? _b : "#cccccc";
  row.appendChild(input);
  if (trailingAction) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "tb-color-trailing-btn";
    btn.setAttribute("aria-label", trailingAction.ariaLabel);
    btn.title = trailingAction.ariaLabel;
    btn.innerHTML = trailingAction.icon;
    btn.addEventListener("click", trailingAction.onClick);
    row.appendChild(btn);
  }
  input.addEventListener("input", () => {
    swatch.style.backgroundColor = input.value;
    const isGrey2 = GREY_SLOT_IDS.includes(slotId);
    if (isGrey2) {
      applyThemeGreysToApp();
    } else {
      applyThemeColorsToApp();
      if (slotId === "theme-primary") {
        updateDerivedSwatches();
        updateGreysFromPrimary(input.value);
      }
      if (slotId === "theme-secondary") {
        updateDerivedSwatches();
      }
    }
    onThemeChange == null ? void 0 : onThemeChange();
  });
  return row;
}
function buildDerivedRow(slotId) {
  const row = document.createElement("div");
  row.className = "tb-derived-row";
  for (const variant of ["lighter", "darker"]) {
    const wrap = document.createElement("div");
    wrap.className = "tb-derived-wrap";
    const swatch = document.createElement("span");
    swatch.id = `${slotId}-${variant}`;
    swatch.className = "tb-swatch tb-swatch--derived";
    const lbl = document.createElement("span");
    lbl.className = "tb-derived-label";
    lbl.textContent = variant.charAt(0).toUpperCase() + variant.slice(1);
    wrap.appendChild(swatch);
    wrap.appendChild(lbl);
    row.appendChild(wrap);
  }
  return row;
}
function createThemeBuilderPage(options = {}) {
  var _a;
  const { savedSnapshot: _savedSnapshot, savedPaletteId, onThemeChange, onPaletteChange } = options;
  const root = document.createElement("div");
  root.setAttribute("role", "main");
  root.className = "ds-theme-builder-page";
  const notifyThemeChange = () => onThemeChange == null ? void 0 : onThemeChange(getThemeSnapshot());
  let currentPalette = (_a = FLAT_UI_PALETTES.find((p) => p.id === savedPaletteId)) != null ? _a : FLAT_UI_PALETTES[0];
  function autoPickComplement() {
    const primaryInput = document.getElementById("theme-primary");
    if (!(primaryInput == null ? void 0 : primaryInput.value) || !currentPalette) return;
    const complement = getComplementaryFromPalette(primaryInput.value, currentPalette);
    if (complement) setThemeColor("theme-secondary", complement);
    notifyThemeChange();
  }
  const paletteCard = createCard({ title: "Color Palette", padding: "md" });
  const palettesContainer = document.createElement("div");
  paletteCard.appendChild(palettesContainer);
  root.appendChild(paletteCard);
  const semanticCard = createCard({ title: "Theme \u2014 Semantic Colors", padding: "md" });
  const semanticGrid = document.createElement("div");
  semanticGrid.className = "tb-color-grid";
  for (const slotId of SEMANTIC_SLOT_IDS) {
    const col = document.createElement("div");
    col.className = "tb-color-col";
    if (slotId === "theme-secondary") {
      col.appendChild(
        buildColorRow(
          slotId,
          {
            icon: ICON_COMPLEMENT,
            ariaLabel: "Auto-pick complementary color from palette",
            onClick: autoPickComplement
          },
          notifyThemeChange
        )
      );
    } else {
      col.appendChild(buildColorRow(slotId, void 0, notifyThemeChange));
    }
    if (slotId === "theme-primary" || slotId === "theme-secondary") {
      col.appendChild(buildDerivedRow(slotId));
    }
    semanticGrid.appendChild(col);
  }
  semanticCard.appendChild(semanticGrid);
  root.appendChild(semanticCard);
  const greysCard = createCard({ title: "Theme \u2014 Gray Scale", padding: "md" });
  const greysGrid = document.createElement("div");
  greysGrid.className = "tb-color-grid";
  for (const slotId of GREY_SLOT_IDS) {
    const col = document.createElement("div");
    col.className = "tb-color-col";
    col.appendChild(buildColorRow(slotId, void 0, notifyThemeChange));
    greysGrid.appendChild(col);
  }
  greysCard.appendChild(greysGrid);
  root.appendChild(greysCard);
  renderPalettes(palettesContainer, {
    initialPaletteId: savedPaletteId,
    onPaletteChange: (id) => {
      var _a2;
      currentPalette = (_a2 = FLAT_UI_PALETTES.find((p) => p.id === id)) != null ? _a2 : currentPalette;
      onPaletteChange == null ? void 0 : onPaletteChange(id);
      notifyThemeChange();
    }
  });
  updateDerivedSwatches();
  return root;
}
export {
  FLAT_UI_PALETTES,
  THEME_SLOT_IDS,
  THEME_SLOT_LABELS,
  applyCssFromSnapshot,
  applyPaletteToThemeBuilder,
  applyThemeColorsToApp,
  applyThemeFromSnapshot,
  applyThemeGreysToApp,
  computeTextOnTokens,
  computeThemeSnapshotForPalette,
  contrastingTextColor,
  copyThemeHexToClipboard,
  createBadge,
  createButton,
  createCard,
  createCheckbox,
  createCitationChip,
  createCollapsiblePanel,
  createDropdown,
  createInput,
  createLookupFieldGroup,
  createMultiSelect,
  createRadioGroup,
  createSearchField,
  createTable,
  createTabset,
  createTextarea,
  createThemeBuilderPage,
  createToggle,
  createTooltip,
  createUserMenu,
  deriveDarker,
  deriveLighter,
  formatResourceFetchErrorMessage,
  getButtonClassName,
  getComplementaryFromPalette,
  getThemeSnapshot,
  renderPalettes,
  setThemeColor,
  updateDerivedSwatches,
  updateGreysFromPrimary
};
//# sourceMappingURL=index.mjs.map